"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2287],{

/***/ 290331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HR": function() { return /* binding */ IMAGE_SHAPE_OVERRIDING_GLOBAL_STYLE; },
/* harmony export */   "JH": function() { return /* binding */ getCardConfigurations; },
/* harmony export */   "WR": function() { return /* binding */ getCurrentClass; },
/* harmony export */   "bR": function() { return /* binding */ getOverlayWrapperStyles; },
/* harmony export */   "cw": function() { return /* binding */ getShapeStyles; },
/* harmony export */   "wo": function() { return /* binding */ getTextContainerStyles; },
/* harmony export */   "z4": function() { return /* binding */ getOverlayTextStyles; }
/* harmony export */ });
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(150361);
/* harmony import */ var lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(291850);


var IMAGE_SHAPE_OVERRIDING_GLOBAL_STYLE = [
    "circle",
    "arch",
    "blob"
];
var getShapeStyles = function(cardShape) {
    var cardWidth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, isFullWidthImgInCard = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    switch(cardShape){
        case "circle":
            return [
                {
                    className: "!tw-rounded-[50%]",
                    style: {}
                }
            ];
        case "arch":
            return [
                {
                    className: "!tw-rounded-es-[0px] !tw-rounded-ee-[0px]",
                    style: {
                        borderStartStartRadius: cardWidth ? "".concat(cardWidth / 2, "px") : "50%",
                        borderStartEndRadius: cardWidth ? "".concat(cardWidth / 2, "px") : "50%"
                    }
                }, 
            ];
        case "blob":
            return [
                {
                    className: "!tw-rounded-[30%_70%_70%_30%_/_30%_47%_53%_70%]"
                },
                {
                    className: "!tw-rounded-[54%_46%_70%_30%_/_19%_79%_21%_81%]"
                },
                {
                    className: "!tw-rounded-[87%_13%_60%_40%_/_30%_93%_7%_70%]"
                },
                {
                    className: "!tw-rounded-[67%_33%_16%_84%_/_63%_52%_48%_37%]"
                },
                {
                    className: "!tw-rounded-[72%_28%_69%_31%_/_67%_57%_43%_33%]"
                }, 
            ];
        default:
            return [
                {
                    className: isFullWidthImgInCard ? "tw-rounded-es-[0px] tw-rounded-ee-[0px]" : "",
                    style: {}
                }, 
            ];
    }
};
var getCurrentClass = function(type) {
    switch(type){
        case "zoomInCard":
        case "zoomIn":
            return "zoomInOnHover";
        case "ambient":
            return "ambientOnHover";
        case "shadow":
            return "containerShadow";
        default:
            return "";
    }
};
var getOverlayWrapperStyles = function(configData) {
    var isTextNameBelow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref;
    var ref1 = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default()((configData === null || configData === void 0 ? void 0 : (ref = configData.contentConfig) === null || ref === void 0 ? void 0 : ref.textConfig) || {}), xAlignment = ref1.xAlignment, yAlignment = ref1.yAlignment, overlayOpacity = ref1.overlayOpacity;
    var styles = {
        justifyContent: "",
        alignItems: "",
        background: isTextNameBelow ? "" : "rgba(0,0,0,".concat(overlayOpacity / 100, ")")
    };
    switch(yAlignment){
        case "top":
            styles.justifyContent = "flex-start";
            break;
        case "middle":
            styles.justifyContent = "center";
            break;
        case "bottom":
            styles.justifyContent = "flex-end";
            break;
        default:
            styles.justifyContent = "flex-end";
            break;
    }
    switch(xAlignment){
        case "left":
            styles.alignItems = "flex-start";
            break;
        case "center":
            styles.alignItems = "center";
            break;
        case "right":
            styles.alignItems = "flex-end";
            break;
        default:
            styles.alignItems = "flex-end";
            break;
    }
    return styles;
};
var getTextContainerStyles = function(configData) {
    var ref;
    var xAlignment = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default()((configData === null || configData === void 0 ? void 0 : (ref = configData.contentConfig) === null || ref === void 0 ? void 0 : ref.textConfig) || {}).xAlignment;
    var styles = {
        justifyContent: "flex-start"
    };
    var className = "";
    switch(xAlignment){
        case "left":
            className = "!tw-justify-start";
            break;
        case "center":
            className = "!tw-justify-center";
            break;
        case "right":
            className = "!tw-justify-end";
            break;
    }
    return {
        styles: styles,
        className: className
    };
};
var getOverlayTextStyles = function(configData) {
    var buttonData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    var ref1 = lodash_cloneDeep__WEBPACK_IMPORTED_MODULE_0___default()((configData === null || configData === void 0 ? void 0 : (ref = configData.contentConfig) === null || ref === void 0 ? void 0 : ref.textConfig) || {}), textSize = ref1.textSize, textCase = ref1.textCase, colorScheme = ref1.colorScheme, textThicness = ref1.textThicness, xAlignment = ref1.xAlignment;
    var styles = {
        fontSize: "",
        textTransform: textCase,
        lineHeight: "1",
        color: colorScheme === null || colorScheme === void 0 ? void 0 : colorScheme.text,
        background: "",
        width: "auto",
        padding: "0px",
        textAlign: "unset",
        fontWeight: "400"
    };
    switch(xAlignment){
        case "left":
            styles.textAlign = "left";
            break;
        case "center":
            styles.textAlign = "center";
            break;
        case "right":
            styles.textAlign = "right";
            break;
    }
    // if (colorScheme.background) {
    //   (styles.background = colorScheme.background), (styles.width = '100%');
    //   styles.padding = '8px';
    //   styles.textAlign = 'center';
    // }
    switch(textSize){
        case "extraSmall":
            styles.fontSize = "12px";
            styles.lineHeight = "1";
            break;
        case "small":
            styles.fontSize = "14px";
            styles.lineHeight = "1";
            break;
        case "medium":
            styles.fontSize = "16px";
            styles.lineHeight = "1.2";
            break;
        case "large":
            styles.fontSize = "18px";
            styles.lineHeight = "1.2";
            break;
        case "extraLarge":
            styles.fontSize = "20px";
            styles.lineHeight = "1.2";
            break;
        default:
            styles.fontSize = "16px";
            styles.lineHeight = "1.1";
            break;
    }
    switch(textThicness){
        case "thin":
            styles.fontWeight = "300";
            break;
        case "regular":
            styles.fontWeight = "400";
            break;
        case "medium":
            styles.fontWeight = "500";
            break;
        case "bold":
            styles.fontWeight = "700";
            break;
        default:
            styles.fontWeight = "400";
            break;
    }
    if (buttonData && buttonData.type !== src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_1__/* .BUTTON_TYPE.TEXTUAL */ .JB.TEXTUAL) {
        styles.textAlign = "center";
    }
    return styles;
};
var getCardConfigurations = function(cardFrameConfig) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var isNonTextualElementPresent = ((ref2 = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref = cardFrameConfig.contentConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonConfig) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
        return item.isShow && item.type !== "textual";
    })) === null || ref2 === void 0 ? void 0 : ref2.length) || ((ref6 = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref3 = cardFrameConfig.contentConfig) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.textConfig) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.appearanceButton) === null || ref5 === void 0 ? void 0 : ref5.filter(function(item) {
        return item.isShow && item.type !== "textual";
    })) === null || ref6 === void 0 ? void 0 : ref6.length);
    // If no button layout was selected
    var isButtonLayout = (ref9 = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref7 = cardFrameConfig.contentConfig) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.buttonConfig) === null || ref8 === void 0 ? void 0 : ref8.filter(function(item) {
        return item.isShow;
    })) === null || ref9 === void 0 ? void 0 : ref9.length;
    var isTextNameBelow = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref10 = cardFrameConfig.contentConfig) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.textConfig) === null || ref11 === void 0 ? void 0 : ref11.type) === "below";
    var isCollectionNameVisible = !!(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref12 = cardFrameConfig.contentConfig) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.textConfig) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.appearanceButton) === null || ref14 === void 0 ? void 0 : ref14.find(function(buttonData) {
        return buttonData.isShow;
    }));
    return {
        isNonTextualElementPresent: isNonTextualElementPresent,
        isButtonLayout: isButtonLayout,
        isTextNameBelow: isTextNameBelow,
        isCollectionNameVisible: isCollectionNameVisible
    };
};


/***/ }),

/***/ 24200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sk": function() { return /* binding */ INITIAL_SCROLL_PERCENTAGE; },
/* harmony export */   "Tf": function() { return /* binding */ getBlogData; },
/* harmony export */   "ns": function() { return /* binding */ onCarouselScroll; }
/* harmony export */ });
/* unused harmony exports MAX_SECTION_WIDTH, BLOG_SECTION_MAX_WIDTH, MAX_CARD_HEIGHT, MAX_CARD_WIDTH, MIN_CARD_WIDTH, MIN_CARD_HEIGHT, MAX_NUM_ROWS_DESKTOP, MAX_NUM_ROWS_MOBILE_ONE_COL, MAX_NUM_ROWS_MOBILE_TWO_COL, MULTI_COLUMN_MIN_WIDTH, MULTI_COLUMN_MIN_WIDTH_MOBILE, MIN_LOGO_SLIDER_CARD_WIDTH, MAX_PRODUCT_REEL_CARD_WIDTH_DESKTOP, MAX_PRODUCT_REEL_CARD_WIDTH_MOBILE, MIN_PRODUCT_REEL_CARD_WIDTH_DESKTOP, MIN_PRODUCT_REEL_CARD_WIDTH_MOBILE, MAX_PRODUCT_REEL_CARD_HEIGHT, MIN_PRODUCT_REEL_CARD_HEIGHT, MAX_LOGO_SLIDER_CARD_WIDTH, MAX_LOGO_SLIDER_HEIGHT, MIN_LOGO_SLIDER_HEIGHT, getContainerTracks, getOneCellGeometry, getDisplayLabelStyles, getShift, getArrowMethods, getCardFrameCustomStyle, getGridGapsForAxes, getReelCardConfigs, isLogoSliderAutoScroll, isLogoSliderFullWidth, isTestimonialSliderFullWidth, getRenderCardOverrides, getPaddingForInstaWidget */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(269396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var _CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(290331);
/* harmony import */ var _components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16902);
/* harmony import */ var src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(442381);







var MAX_SECTION_WIDTH = 1600;
var BLOG_SECTION_MAX_WIDTH = 1200;
var MAX_CARD_HEIGHT = 680;
var MAX_CARD_WIDTH = 680;
var MIN_CARD_WIDTH = 120; // 170; // 100;
var MIN_CARD_HEIGHT = 120; // 170; // 100;
var MAX_NUM_ROWS_DESKTOP = 2; // 170; // 100;
var MAX_NUM_ROWS_MOBILE_ONE_COL = 4;
var MAX_NUM_ROWS_MOBILE_TWO_COL = 6;
var INITIAL_SCROLL_PERCENTAGE = 20;
var MULTI_COLUMN_MIN_WIDTH = 150;
var MULTI_COLUMN_MIN_WIDTH_MOBILE = 100;
var MIN_LOGO_SLIDER_CARD_WIDTH = 50;
var MAX_PRODUCT_REEL_CARD_WIDTH_DESKTOP = 350;
var MAX_PRODUCT_REEL_CARD_WIDTH_MOBILE = 220;
var MIN_PRODUCT_REEL_CARD_WIDTH_DESKTOP = 172;
var MIN_PRODUCT_REEL_CARD_WIDTH_MOBILE = 150;
var MAX_PRODUCT_REEL_CARD_HEIGHT = 450;
var MIN_PRODUCT_REEL_CARD_HEIGHT = 250;
var MAX_LOGO_SLIDER_CARD_WIDTH = 160;
var MAX_LOGO_SLIDER_HEIGHT = 84;
var MIN_LOGO_SLIDER_HEIGHT = 50;
function getNumsOfColumn(isMobile, configData) {
    var ref = configData || {}, numColumnsDesktop = ref.numColumnsDesktop, numColumnsMobile = ref.numColumnsMobile, _mobileImagePosition = ref.mobileImagePosition, mobileImagePosition = _mobileImagePosition === void 0 ? "" : _mobileImagePosition;
    if ((configData === null || configData === void 0 ? void 0 : configData.type) === "blog") {
        return isMobile ? mobileImagePosition === "left" ? 1 : numColumnsMobile : numColumnsDesktop;
    }
    return isMobile ? numColumnsMobile : numColumnsDesktop;
}
// Returns number of columns
function getContainerTracks(param) {
    var isLayoutCarousel = param.isLayoutCarousel, itemCount = param.itemCount, isMobile = param.isMobile, listPresentationConfig = param.listPresentationConfig, _expandSelectedReel = param.expandSelectedReel, expandSelectedReel = _expandSelectedReel === void 0 ? false : _expandSelectedReel, _isTestimonials = param.isTestimonials, isTestimonials = _isTestimonials === void 0 ? false : _isTestimonials;
    var numColumnsOriginal = getNumsOfColumn(isMobile, listPresentationConfig);
    var numColumns = numColumnsOriginal;
    var numColumnsMax = itemCount < numColumns ? itemCount : numColumns;
    if (expandSelectedReel) {
        numColumns = 1;
    }
    // if (!useStaticNumColumns && itemCount < numColumns) {
    //   numColumns = itemCount;
    // }
    var numRowsForGrid = isMobile ? numColumns == 1 ? MAX_NUM_ROWS_MOBILE_ONE_COL : MAX_NUM_ROWS_MOBILE_TWO_COL : MAX_NUM_ROWS_DESKTOP;
    var numRows = isLayoutCarousel ? 1 : numRowsForGrid; // for grid -> 'auto', for carousel -> 1;
    if (numRows > itemCount / numColumns) {
        numRows = Math.ceil(itemCount / numColumns);
    }
    // if testimonial, grid -> max rows -> 2
    if (!isLayoutCarousel && isTestimonials) {
        numRows = Math.min(2, Math.ceil(itemCount / numColumns));
    }
    return {
        numColumns: numColumns,
        numRows: numRows,
        numColumnsOriginal: numColumnsOriginal,
        numColumnsMax: numColumnsMax
    };
}
function getCardMinMaxWidth(type, isMobile, forType) {
    switch(type){
        case "icon":
        case "image":
            return forType === "max" ? MAX_CARD_WIDTH : isMobile ? MULTI_COLUMN_MIN_WIDTH_MOBILE : MULTI_COLUMN_MIN_WIDTH;
        case "logoSlider":
            return forType === "max" ? MAX_LOGO_SLIDER_CARD_WIDTH : MIN_LOGO_SLIDER_CARD_WIDTH;
        case "featuredReels":
            return forType === "max" ? !isMobile ? MAX_PRODUCT_REEL_CARD_WIDTH_DESKTOP : MAX_PRODUCT_REEL_CARD_WIDTH_MOBILE : !isMobile ? MIN_PRODUCT_REEL_CARD_WIDTH_DESKTOP : MIN_PRODUCT_REEL_CARD_WIDTH_MOBILE;
        case "testimonials":
            return -1;
        default:
            return forType === "max" ? MAX_CARD_WIDTH : MIN_CARD_WIDTH;
    }
}
function getMaxHeight(type) {
    switch(type){
        case "logoSlider":
            return MAX_LOGO_SLIDER_HEIGHT;
        case "featuredReels":
            return MAX_PRODUCT_REEL_CARD_HEIGHT;
        default:
            return MAX_CARD_HEIGHT;
    }
}
// Width for each column (product item)
function getOneCellGeometry(param) {
    var cardContainerWidthForEachCell = param.cardContainerWidthForEachCell, containerTracks = param.containerTracks, aspectRatio = param.aspectRatio, widthAdditionals = param.widthAdditionals, type = param.type, isMobile = param.isMobile, isLayoutTypeCard = param.isLayoutTypeCard;
    var width = cardContainerWidthForEachCell / containerTracks.numColumns;
    // Reduce width slightly for each card so that an overflowed card is shown slightly to nudge the user to scroll
    width = width + widthAdditionals;
    var minWidth = getCardMinMaxWidth(type, isMobile, "min");
    var maxWidth = getCardMinMaxWidth(type, isMobile, "max");
    if (width > maxWidth && maxWidth > 0) width = maxWidth;
    if (width < minWidth && minWidth > 0) width = minWidth;
    // extract aspect ratio
    var ref = _sliced_to_array(aspectRatio.split(":").map(function(item) {
        return +item;
    }), 2), widthRatio = ref[0], heightRatio = ref[1];
    // calculate height
    var height = width * (heightRatio / widthRatio);
    if (height > getMaxHeight(type)) {
        height = getMaxHeight(type);
        width = ![
            "logoSlider",
            "testimonials"
        ].includes(type) ? height * (widthRatio / heightRatio) : width;
    }
    // Meanwhile the width will be used to calculate the normal layout related things because the card will achieve the width
    // as calculated because in case of card layout border width will get added
    return {
        width: width,
        height: height,
        itemWidth: isLayoutTypeCard ? width - 2 // remove horizontal border width as border wil be applied to child of 1px
         : width
    };
}
function getDisplayLabelStyles(configData) {
    var alwaysKeepLeft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var textAlign = configData === null || configData === void 0 ? void 0 : configData.textAlign;
    var styles = {
        alignItems: "",
        width: "100%"
    };
    if (alwaysKeepLeft) {
        styles.alignItems = "flex-start";
        return styles;
    }
    switch(textAlign){
        case "left":
            styles.alignItems = "flex-start";
            break;
        case "center":
            styles.alignItems = "center";
            break;
        default:
            styles.alignItems = "center";
            break;
    }
    return styles;
}
function onCarouselScroll(param) {
    var e = param.e, setCarouselIndicatorConfigs = param.setCarouselIndicatorConfigs, _slideOffset = param.slideOffset, slideOffset = _slideOffset === void 0 ? 0 : _slideOffset, _widthOffset = param.widthOffset, widthOffset = _widthOffset === void 0 ? 0 : _widthOffset;
    var sectionViewportWidth = Math.floor(e.currentTarget.clientWidth);
    var sectionScrollWidth = Math.floor(e.currentTarget.scrollWidth);
    var currentScrollPosition = Math.floor(e.currentTarget.scrollLeft);
    var scrollPercent = currentScrollPosition / (sectionScrollWidth - sectionViewportWidth) * 100;
    // INITIAL_SCROLL_PERCENTAGE move advantage given
    var offsetPosition = scrollPercent * (INITIAL_SCROLL_PERCENTAGE / 100);
    // const currentFocusedSectionItem = Math.ceil(
    //   (currentScrollPosition + sectionViewportWidth) / sectionViewportWidth
    // );
    var currentFocusedSectionItem = Math.ceil(currentScrollPosition / (slideOffset - widthOffset)) + 1; // As this starts with 1 already
    setCarouselIndicatorConfigs(function(data) {
        var newScrollPercentage = Math.ceil(scrollPercent - offsetPosition + INITIAL_SCROLL_PERCENTAGE);
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
            direction: newScrollPercentage >= data.scrollPercentage ? "to-right" : "to-left",
            scrollPercentage: newScrollPercentage,
            currentFocusedSectionItem: Math.ceil(newScrollPercentage) === INITIAL_SCROLL_PERCENTAGE || Math.floor(newScrollPercentage) === INITIAL_SCROLL_PERCENTAGE ? 1 : currentFocusedSectionItem,
            currentFocusedSectionExact: currentScrollPosition / (slideOffset - widthOffset) + 1
        });
    });
}
function getShift(itemsContainerRef, showAutoRotation, slideOffset, columnShiftWidth) {
    var ref;
    var currentScrollPosition = itemsContainerRef === null || itemsContainerRef === void 0 ? void 0 : (ref = itemsContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollLeft;
    var shift = !showAutoRotation ? slideOffset : columnShiftWidth;
    var extraCoveredShift = Math.floor(currentScrollPosition % shift);
    var remainingShiftForward = shift - extraCoveredShift;
    var remainingShiftBackward = shift + extraCoveredShift;
    return {
        remainingShiftBackward: remainingShiftBackward,
        remainingShiftForward: Math.floor(remainingShiftForward) || shift + remainingShiftForward
    };
}
function getArrowMethods(itemsContainerRef, slideOffset, showAutoRotation, columnShiftWidth, columnGap, stopAutoRotation, startAutoRotation) {
    var onNextArrowClick = function onNextArrowClick() {
        var ref;
        var remainingShiftForward = getShift(itemsContainerRef, showAutoRotation, slideOffset, columnShiftWidth).remainingShiftForward;
        stopAutoRotation();
        (ref = itemsContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
            top: 0,
            left: remainingShiftForward,
            behavior: "smooth"
        });
        startAutoRotation();
    };
    var onPrevArrowClick = function onPrevArrowClick() {
        var ref;
        var remainingShiftBackward = getShift(itemsContainerRef, showAutoRotation, slideOffset, columnShiftWidth).remainingShiftBackward;
        stopAutoRotation();
        (ref = itemsContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
            top: 0,
            left: -remainingShiftBackward,
            behavior: "smooth"
        });
        startAutoRotation();
    };
    var carouselScrollTo = function carouselScrollTo(index) {
        var instantScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref;
        stopAutoRotation();
        (ref = itemsContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            left: columnShiftWidth * index,
            behavior: instantScroll ? "instant" : "smooth"
        });
        startAutoRotation();
    };
    return {
        onNextArrowClick: onNextArrowClick,
        onPrevArrowClick: onPrevArrowClick,
        carouselScrollTo: carouselScrollTo
    };
}
/* No padding is applied when carousel layout is chosen on mobile so scroll is from one screen edge
to another, so a margin is given on first & last element to give initial spacing before scroll starts **/ var getCardFrameCustomStyle = function(param) {
    var isLayoutCarousel = param.isLayoutCarousel, isMobile = param.isMobile, contentHorizontalPadding = param.contentHorizontalPadding, index = param.index, arr = param.arr;
    var margin = "";
    if (isLayoutCarousel && isMobile) {
        if (!index) margin = "0px 0px 0px ".concat(contentHorizontalPadding, "px");
        if (index === arr.length - 1) margin = "0px  ".concat(contentHorizontalPadding, "px 0px 0px");
    }
    return {
        margin: margin
    };
};
function getColumnGap(param) {
    var isMobile = param.isMobile, type = param.type, isLayoutTypeCard = param.isLayoutTypeCard, listPresentationConfig = param.listPresentationConfig, expandSelectedReel = param.expandSelectedReel;
    if (type === "icon" || type === "image") {
        return isMobile ? isLayoutTypeCard ? 8 : 16 : (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.columnGap) >= 0 ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.columnGap : 44;
    }
    if (type === "logoSlider") return isMobile ? !isLayoutTypeCard ? 16 : 10 : 20;
    if (type === "blog") return isMobile ? 10 : 32;
    if (type === "featuredReels" && expandSelectedReel) return isMobile ? 20 : 32;
    if (type === "testimonials") return isMobile ? !isLayoutTypeCard ? 16 : 12 : !isLayoutTypeCard ? 44 : 20;
    if (type === ADMIN_WIDGETS_NAMES.GALLERY) return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap) >= 0 ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap : 20;
    if (type === "instagram") return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.showGapBetweenImages) ? 0 : 8;
    return isMobile ? 10 : 20;
}
function getRowGap(isMobile, type, isLayoutTypeCard, isTextNameBelow, isCollectionNameVisible, numColumns, listPresentationConfig) {
    if (type === "icon" || type === "image") return !isMobile ? 44 : isLayoutTypeCard ? 8 : 16;
    if (type === "logoSlider") return !isMobile ? 20 : !isLayoutTypeCard ? 20 : 10;
    if (type === "blog") return isMobile ? isLayoutTypeCard ? 10 : 24 : 32;
    if (type === "testimonials") return isMobile ? !isLayoutTypeCard ? 44 : 12 : !isLayoutTypeCard ? 64 : 20;
    if (type === ADMIN_WIDGETS_NAMES.GALLERY) return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap) >= 0 ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap : 20;
    if (type === "instagram") return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.showGapBetweenImages) ? 0 : 8;
    return !isMobile ? isTextNameBelow && isCollectionNameVisible ? 40 : 20 : isTextNameBelow && isCollectionNameVisible ? 36 : 10;
}
var getGridGapsForAxes = function(param) {
    var isMobile = param.isMobile, cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig, type = param.type, isLayoutTypeCard = param.isLayoutTypeCard, expandSelectedReel = param.expandSelectedReel, numColumns = param.numColumns;
    var ref = getCardConfigurations(cardFrameConfig), isTextNameBelow = ref.isTextNameBelow, isCollectionNameVisible = ref.isCollectionNameVisible;
    return {
        columnGap: getColumnGap({
            isMobile: isMobile,
            type: type,
            isLayoutTypeCard: isLayoutTypeCard,
            listPresentationConfig: listPresentationConfig,
            expandSelectedReel: expandSelectedReel
        }),
        rowGap: getRowGap(isMobile, type, isLayoutTypeCard, isTextNameBelow, isCollectionNameVisible, numColumns, listPresentationConfig)
    };
};
var getReelCardConfigs = function(config) {
    var isCardLayout = (config === null || config === void 0 ? void 0 : config.appearance) === "card";
    var isFullWidth = isCardLayout && (config === null || config === void 0 ? void 0 : config.imageWidth) === "fullWidth";
    var style = {
        background: isCardLayout ? config === null || config === void 0 ? void 0 : config.backgroundColor : "transparent",
        borderColor: isCardLayout ? config === null || config === void 0 ? void 0 : config.borderColor : "#111C361F"
    };
    var className = isCardLayout ? "tw-border-[1px] tw-border-solid" : "";
    return {
        style: style,
        className: className,
        isCardLayout: isCardLayout,
        isFullWidth: isFullWidth
    };
};
function isLogoSliderAutoScroll(param) {
    var cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig;
    return (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.autoScroll) && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel";
}
function isLogoSliderFullWidth(param) {
    var cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig;
    return (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.scrollFullWidth) && (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.autoScroll) && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel";
}
function isTestimonialSliderFullWidth(param) {
    var listPresentationConfig = param.listPresentationConfig;
    var ref;
    var isTestimonial = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === "testimonials";
    var isAutoScroll = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.autoPlayConfig) === null || ref === void 0 ? void 0 : ref.type) === SCROLL_TYPE.AUTO_SCROLL;
    return isTestimonial && isAutoScroll;
}
var getRenderCardOverrides = function(param) {
    var listPresentationConfig = param.listPresentationConfig, sectionColors = param.sectionColors;
    var ref, ref1, ref2, ref3;
    if (!(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.defaultOverrides) === null || ref1 === void 0 ? void 0 : ref1.isEnabled)) {
        return "";
    }
    switch(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref2 = listPresentationConfig.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.defaultOverrides) === null || ref3 === void 0 ? void 0 : ref3.colorSchemeName){
        case "custom":
            return sectionColors === null || sectionColors === void 0 ? void 0 : sectionColors.text;
        case "white":
            return "#ffffff";
        default:
            return "";
    }
};
function getBlogData(blogList) {
    var simplifiedBlogData = blogList === null || blogList === void 0 ? void 0 : blogList.map(function(data) {
        return {
            imageDetail: {
                url: (data === null || data === void 0 ? void 0 : data.featured_image) || ""
            },
            title: (data === null || data === void 0 ? void 0 : data.page_name) || "",
            description: (data === null || data === void 0 ? void 0 : data.excerpt) || "",
            date: (data === null || data === void 0 ? void 0 : data.updated_at) || "",
            slug: (data === null || data === void 0 ? void 0 : data.slug_url) || ""
        };
    });
    return simplifiedBlogData;
}
function getPaddingForInstaWidget(listPresentation, isMobile) {
    var isLayout2 = listPresentation.layoutName === COMMON_LAYOUT_TYPE.TWO;
    if (isMobile) {
        if (isLayout2) {
            return "20px 20px 0 20px";
        } else {
            return "0px 20px";
        }
    } else if (!isMobile) {
        if (isLayout2) {
            return "20px 0 0 0";
        } else {
            return "0";
        }
    }
}


/***/ }),

/***/ 431308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lc": function() { return /* binding */ WIDGET_TYPE; },
/* harmony export */   "an": function() { return /* binding */ CONTAINER_TYPE; },
/* harmony export */   "yP": function() { return /* binding */ LAYOUT_TYPE; }
/* harmony export */ });
var LAYOUT_TYPE = {
    layout1: "layout1",
    layout2: "layout2",
    layout3: "layout3",
    layout4: "layout4",
    layout5: "layout5"
};
var WIDGET_TYPE = {
    INSTAGRAM_POST: "instagramPost",
    COLLECTION: "collection",
    CATEGORY: "category",
    CATEGORIES: "categories",
    FEATURE: "feature",
    FEATURED_COLLECTION: "featuredCollection",
    FEATURED_REELS: "featuredReels",
    TESTIMONIALS: "testimonials",
    LOGO_SLIDER: "logoSlider",
    BLOG: "blog",
    ICON: "icon",
    IMAGE: "image",
    INSTAGRAM: "instagram"
};
var CONTAINER_TYPE = {
    GRID: "grid",
    CAROUSEL: "carousel"
};


/***/ }),

/***/ 101657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fJ": function() { return /* binding */ ListPresentationContext; },
  "ds": function() { return /* binding */ useListPresentationContextData; }
});

// UNUSED EXPORTS: ListPresentationContextCreator

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(662946);
// EXTERNAL MODULE: ./src/constants/widgets.ts
var widgets = __webpack_require__(442381);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/constant.ts
var constant = __webpack_require__(431308);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useGetContentTypeConditions.ts



function useGetContentTypeConditions(param) {
    var listPresentationConfig = param.listPresentationConfig;
    var ref;
    var contentType = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.contentItems) === null || ref === void 0 ? void 0 : ref.type;
    var contentTypeConditions = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return {
            collection: contentType === constant/* WIDGET_TYPE.COLLECTION */.Lc.COLLECTION,
            category: [
                constant/* WIDGET_TYPE.CATEGORY */.Lc.CATEGORY,
                constant/* WIDGET_TYPE.CATEGORIES */.Lc.CATEGORIES
            ].includes(contentType),
            featured: (ref = contentType === null || contentType === void 0 ? void 0 : contentType.toLocaleLowerCase()) === null || ref === void 0 ? void 0 : (ref1 = ref.includes) === null || ref1 === void 0 ? void 0 : ref1.call(ref, constant/* WIDGET_TYPE.FEATURE */.Lc.FEATURE),
            featuredCollection: contentType === null || contentType === void 0 ? void 0 : (ref2 = contentType.includes) === null || ref2 === void 0 ? void 0 : ref2.call(contentType, constant/* WIDGET_TYPE.FEATURED_COLLECTION */.Lc.FEATURED_COLLECTION),
            featuredReels: contentType === null || contentType === void 0 ? void 0 : (ref3 = contentType.includes) === null || ref3 === void 0 ? void 0 : ref3.call(contentType, constant/* WIDGET_TYPE.FEATURED_REELS */.Lc.FEATURED_REELS),
            testimonials: contentType === null || contentType === void 0 ? void 0 : (ref4 = contentType.includes) === null || ref4 === void 0 ? void 0 : ref4.call(contentType, constant/* WIDGET_TYPE.TESTIMONIALS */.Lc.TESTIMONIALS),
            logoSlider: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === constant/* WIDGET_TYPE.LOGO_SLIDER */.Lc.LOGO_SLIDER,
            blogs: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === constant/* WIDGET_TYPE.BLOG */.Lc.BLOG,
            featuredTag: contentType === null || contentType === void 0 ? void 0 : (ref5 = contentType.includes) === null || ref5 === void 0 ? void 0 : ref5.call(contentType, "featuredTag"),
            featuredCategory: contentType === null || contentType === void 0 ? void 0 : (ref6 = contentType.includes) === null || ref6 === void 0 ? void 0 : ref6.call(contentType, widgets/* ADMIN_WIDGETS.FEATURED_CATEGORIES.type */.Pe.FEATURED_CATEGORIES.type),
            multiColumn: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === constant/* WIDGET_TYPE.ICON */.Lc.ICON || (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === constant/* WIDGET_TYPE.IMAGE */.Lc.IMAGE,
            multiColumnForIcon: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === constant/* WIDGET_TYPE.ICON */.Lc.ICON,
            multiColumnForImage: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === constant/* WIDGET_TYPE.IMAGE */.Lc.IMAGE,
            gallery: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === widgets/* ADMIN_WIDGETS_NAMES.GALLERY */.G.GALLERY,
            productTestimonial: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === widgets/* ADMIN_WIDGETS_NAMES.PRODUCT_TESTIMONIAL */.G.PRODUCT_TESTIMONIAL,
            instagram: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === constant/* WIDGET_TYPE.INSTAGRAM */.Lc.INSTAGRAM
        };
    }, [
        contentType,
        listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type
    ]);
    return {
        contentTypeConditions: contentTypeConditions
    };
}

// EXTERNAL MODULE: ./src/redux/store/index.js + 44 modules
var store = __webpack_require__(167261);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/utils.ts
var utils = __webpack_require__(24200);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useGetIterableItems.tsx









// This adds a collection in the list if a new collection is added by the merchant from web console
function useGetIterableItems(param) {
    var // old list config set from builder
    listPresentationConfigItems = param.listPresentationConfigItems, _removeNotVisibleItems = param.removeNotVisibleItems, removeNotVisibleItems = _removeNotVisibleItems === void 0 ? false : _removeNotVisibleItems, _defaultItemVisibility = param.defaultItemVisibility, defaultItemVisibility = _defaultItemVisibility === void 0 ? true : _defaultItemVisibility, _fromWidgetOutline = param.fromWidgetOutline, fromWidgetOutline = _fromWidgetOutline === void 0 ? false : _fromWidgetOutline, _contentType = param.contentType, contentType = _contentType === void 0 ? "collection" : _contentType, _dependency = param.dependency, dependency = _dependency === void 0 ? [] : _dependency;
    var ref, ref1, ref2;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,react.useState)(false), moreItemsAvailable = ref3[0], setMoreItemsAvailable = ref3[1];
    var listType = {
        tag: (ref = contentType === null || contentType === void 0 ? void 0 : contentType.toLowerCase()) === null || ref === void 0 ? void 0 : ref.includes("tag"),
        collection: (ref1 = contentType === null || contentType === void 0 ? void 0 : contentType.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("collection"),
        category: (ref2 = contentType === null || contentType === void 0 ? void 0 : contentType.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.includes("category"),
        featuredTag: contentType === "featuredTag",
        featuredCollection: contentType === "featuredCollection",
        featuredCategory: contentType === widgets/* ADMIN_WIDGETS.FEATURED_CATEGORIES.type */.Pe.FEATURED_CATEGORIES.type
    };
    var ref4 = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            latestCollectionProducts: state.catalogReducer.paginatedCollectionItems,
            storeData: state.storeReducer.store,
            latestCategories: state.catalogReducer.categories,
            latestTags: state.catalogReducer.productTags,
            // Featured collection products
            latestCollections: state.catalogReducer.collections,
            // Featured tags/category products
            latestCategoryProducts: state.catalogReducer.catalog_items
        };
    }), latestCollections = ref4.latestCollections, storeData = ref4.storeData, latestCollectionProducts = ref4.latestCollectionProducts, latestCategories = ref4.latestCategories, latestTags = ref4.latestTags, latestCategoryProducts = ref4.latestCategoryProducts;
    var ref5 = (0,react.useState)(null), currentChosenCollection = ref5[0], setCurrentChosenCollection = ref5[1];
    var selectedLatestList = function() {
        if (!contentType) return null;
        if (listType.tag) return latestTags;
        if (listType.collection) return latestCollections;
        return latestCategories;
    }();
    (0,react.useEffect)(function() {
        if (!fromWidgetOutline && Array.isArray(listPresentationConfigItems)) {
            if (listType.featuredCollection || listType.featuredTag || listType.featuredCategory) {
                var shownItem = listPresentationConfigItems === null || listPresentationConfigItems === void 0 ? void 0 : listPresentationConfigItems.find(function(item) {
                    return item === null || item === void 0 ? void 0 : item.isVisible;
                });
                if (!shownItem) {
                    return;
                }
                var list = function() {
                    if (listType.featuredCollection) return latestCollections;
                    if (listType.featuredCategory) return latestCategories;
                    return latestTags;
                }();
                var storeCollection = list === null || list === void 0 ? void 0 : list.find(function(listItem) {
                    return listItem.id === shownItem.id;
                });
                setCurrentChosenCollection(storeCollection);
                // Don't make API calls if data already present in reducer
                var isProductListAlreadyPresent = function() {
                    if (listType.featuredCollection) {
                        return latestCollectionProducts === null || latestCollectionProducts === void 0 ? void 0 : latestCollectionProducts[storeCollection === null || storeCollection === void 0 ? void 0 : storeCollection.id];
                    }
                    return latestCategoryProducts === null || latestCategoryProducts === void 0 ? void 0 : latestCategoryProducts[storeCollection === null || storeCollection === void 0 ? void 0 : storeCollection.id];
                }();
                if (!storeCollection || storeCollection && isProductListAlreadyPresent) {
                    return;
                }
                if (listType.featuredCollection) {
                    dispatch((0,catalog/* fetchPaginatedCollectionItems */.Dl)({
                        storeId: storeData.store_id,
                        collectionId: storeCollection.id
                    }));
                }
                if (listType.featuredTag) {
                    var payload = {
                        store_id: storeData.store_id,
                        category_id: storeCollection.id,
                        category_type: constants/* CATEGORY_TYPE.TAG */.MI.TAG,
                        page_no: 0
                    };
                    dispatch((0,catalog/* fetchCatalogItemsByCategoryId */.Is)(payload));
                }
                if (listType.featuredCategory) {
                    var payload1 = {
                        store_id: storeData.store_id,
                        category_id: storeCollection.id,
                        category_type: constants/* CATEGORY_TYPE.CATEGORY */.MI.CATEGORY,
                        page_no: 0
                    };
                    dispatch((0,catalog/* fetchCatalogItemsByCategoryId */.Is)(payload1));
                }
            }
        }
    }, [
        listPresentationConfigItems, 
    ].concat((0,_to_consumable_array/* default */.Z)(listType.featuredCollection ? [
        latestCollections,
        latestCollectionProducts
    ] : []), (0,_to_consumable_array/* default */.Z)(listType.featuredTag ? [
        latestTags,
        latestCategoryProducts
    ] : []), (0,_to_consumable_array/* default */.Z)(listType.featuredCategory ? [
        latestCategories,
        latestCategoryProducts
    ] : [])));
    var iterableList = (0,react.useMemo)(function() {
        var list = [];
        var newAddedItems = [];
        if (!(Array.isArray(listPresentationConfigItems) || (selectedLatestList === null || selectedLatestList === void 0 ? void 0 : selectedLatestList.length))) {
            return list;
        }
        // For CFE: For product items in a collection/tag/category
        if (!fromWidgetOutline && (listType.featuredCollection || listType.featuredTag || listType.featuredCategory)) {
            var productList = listType.featuredCollection ? latestCollectionProducts : latestCategoryProducts;
            if (productList === null || productList === void 0 ? void 0 : productList[currentChosenCollection === null || currentChosenCollection === void 0 ? void 0 : currentChosenCollection.id]) {
                var interList = [];
                var items = function() {
                    if (Array.isArray(productList[currentChosenCollection.id])) return productList[currentChosenCollection.id];
                    return Object.values(productList[currentChosenCollection.id]);
                }();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Fill interlist with products to be pushed
                    for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        var _interList;
                        if ((interList === null || interList === void 0 ? void 0 : interList.length) >= 13) {
                            !moreItemsAvailable && setMoreItemsAvailable(true);
                            break;
                        } else !Array.isArray(item) ? interList.push(item) : (_interList = interList).push.apply(_interList, (0,_to_consumable_array/* default */.Z)(item || []));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (interList === null || interList === void 0 ? void 0 : interList.length) {
                    var _list;
                    (_list = list).push.apply(_list, (0,_to_consumable_array/* default */.Z)(interList.map(function(productItem) {
                        return {
                            data: productItem,
                            isVisible: true,
                            id: productItem === null || productItem === void 0 ? void 0 : productItem.id,
                            type: "product"
                        };
                    })));
                }
            }
        } else {
            // For collection, categories, tags list
            selectedLatestList.forEach(function(latestListItem) {
                var builderRefItemIndex = listPresentationConfigItems === null || listPresentationConfigItems === void 0 ? void 0 : listPresentationConfigItems.findIndex(function(builderItem) {
                    return (builderItem === null || builderItem === void 0 ? void 0 : builderItem.id) === latestListItem.id;
                });
                var builderItem = (listPresentationConfigItems === null || listPresentationConfigItems === void 0 ? void 0 : listPresentationConfigItems[builderRefItemIndex]) || {};
                var isLatestListItemAlreadyPresent = builderRefItemIndex > -1;
                // Is latest item from backend present in build list, update the data
                if (isLatestListItemAlreadyPresent) {
                    var ref;
                    list[builderRefItemIndex] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, builderItem), {
                        itemCount: latestListItem === null || latestListItem === void 0 ? void 0 : (ref = latestListItem.categories) === null || ref === void 0 ? void 0 : ref.length,
                        data: latestListItem,
                        type: contentType
                    });
                } else {
                    var ref1;
                    newAddedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, builderItem), {
                        id: latestListItem.id,
                        rank: latestListItem.rank || 0,
                        isVisible: defaultItemVisibility,
                        itemCount: latestListItem === null || latestListItem === void 0 ? void 0 : (ref1 = latestListItem.categories) === null || ref1 === void 0 ? void 0 : ref1.length,
                        data: latestListItem,
                        type: contentType
                    }));
                }
            });
        }
        var finalList = list === null || list === void 0 ? void 0 : list.concat(newAddedItems);
        if (removeNotVisibleItems) {
            finalList = finalList === null || finalList === void 0 ? void 0 : finalList.filter(function(item) {
                return item && item.isVisible;
            });
        }
        return finalList;
    }, (0,_to_consumable_array/* default */.Z)(dependency).concat([
        selectedLatestList, 
    ], (0,_to_consumable_array/* default */.Z)(listType.featuredCollection ? [
        latestCollectionProducts,
        currentChosenCollection
    ] : []), (0,_to_consumable_array/* default */.Z)(listType.featuredTag || listType.featuredCategory ? [
        currentChosenCollection,
        latestCategoryProducts
    ] : [])));
    return {
        iterableList: iterableList,
        moreItemsAvailable: moreItemsAvailable
    };
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useGetItemsToIterate.ts





function useGetItemsToIterate(param) {
    var cardFrameConfig = param.cardFrameConfig, props = param.props, listPresentationConfig = param.listPresentationConfig, instaUserData = param.instaUserData;
    var ref, ref1, ref2;
    var contentTypeConditions = useGetContentTypeConditions({
        listPresentationConfig: listPresentationConfig
    }).contentTypeConditions;
    var contentType = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.contentItems) === null || ref === void 0 ? void 0 : ref.type;
    var ref3 = useGetIterableItems({
        listPresentationConfigItems: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref1 = listPresentationConfig.contentItems) === null || ref1 === void 0 ? void 0 : ref1.listItem,
        contentType: contentType,
        removeNotVisibleItems: true,
        dependency: [
            listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref2 = listPresentationConfig.contentItems) === null || ref2 === void 0 ? void 0 : ref2.listItem,
            cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.testimonialsList, 
        ]
    }), iterableListDefault = ref3.iterableList, moreItemsAvailable = ref3.moreItemsAvailable;
    var iterableList = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (contentTypeConditions.multiColumn) return cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref = cardFrameConfig.multiColumnData) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return item === null || item === void 0 ? void 0 : item.isVisible;
        });
        if (contentTypeConditions.logoSlider) {
            var ref3;
            var visibleLogo = cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref3 = cardFrameConfig.multiColumnData) === null || ref3 === void 0 ? void 0 : ref3.filter(function(data) {
                return data === null || data === void 0 ? void 0 : data.isVisible;
            });
            return visibleLogo;
        }
        if (contentTypeConditions.blogs) {
            var ref4, ref5, ref6, ref7, ref8, ref9;
            var blogData = ((ref4 = store/* default.getState */.Z.getState().additionalPagesReducer) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.additionalPageList) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.blog) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.json_data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.blog) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.users_list) === null || ref9 === void 0 ? void 0 : ref9.list) || (props === null || props === void 0 ? void 0 : props.blogData);
            return (0,utils/* getBlogData */.Tf)(blogData);
        }
        if (contentTypeConditions.featuredReels) return (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref1 = cardFrameConfig.reelsData) === null || ref1 === void 0 ? void 0 : ref1.filter(function(reelItem) {
            return !!reelItem.reelUrl;
        })) || [];
        if (contentTypeConditions.testimonials) return (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref2 = cardFrameConfig.testimonialsList) === null || ref2 === void 0 ? void 0 : ref2.filter(function(testimonial) {
            return (testimonial === null || testimonial === void 0 ? void 0 : testimonial.isVisible) !== false;
        })) || [];
        if (contentTypeConditions.gallery) {
            var ref10;
            return (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : (ref10 = cardFrameConfig.imagesData) === null || ref10 === void 0 ? void 0 : ref10.filter(function(galleryData) {
                return (galleryData === null || galleryData === void 0 ? void 0 : galleryData.isVisible) !== false;
            })) || [];
        }
        if (contentTypeConditions.instagram) {
            return instaUserData === null || instaUserData === void 0 ? void 0 : instaUserData.media;
        }
        return iterableListDefault;
    }, [
        iterableListDefault,
        contentTypeConditions,
        cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.multiColumnData
    ]);
    return {
        iterableList: iterableList,
        contentTypeConditions: contentTypeConditions,
        moreItemsAvailable: moreItemsAvailable
    };
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/hooks/useRefSetters.ts

function useRefSetters() {
    var ref = (0,react.useState)(null), itemContainerRef = ref[0], setItemContainerRef = ref[1];
    var ref1 = (0,react.useState)(null), sectionContainerRef = ref1[0], setSectionContainerRef = ref1[1];
    var sectionContainerRefSetter = (0,react.useCallback)(function(node) {
        if (!node) return null;
        setSectionContainerRef(node);
    }, []);
    var itemsContainerRefSetter = (0,react.useCallback)(function(node) {
        if (!node) return null;
        setItemContainerRef(node);
    }, []);
    return {
        sectionContainerRefSetter: sectionContainerRefSetter,
        itemsContainerRefSetter: itemsContainerRefSetter,
        sectionContainerRef: sectionContainerRef,
        itemContainerRef: itemContainerRef
    };
}

// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/utils.ts
var ListPresentationV1_utils = __webpack_require__(608222);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/Testimonials/Constants/index.tsx
var Constants = __webpack_require__(26763);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useAutoScrollOrRotation.tsx
var useAutoScrollOrRotation = __webpack_require__(615030);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/utils.ts
var ProductListWrapper_utils = __webpack_require__(202386);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useSetViewAllBtnConfig.ts



function useSetViewAllBtnConfig(props) {
    var ref;
    var contentTypeConditions = props.contentTypeConditions, isLayoutCarousel = props.isLayoutCarousel, listPresentationConfig = props.listPresentationConfig, moreItemsAvailable = props.moreItemsAvailable, itemCountTotal = props.itemCountTotal, numItemsToShow = props.numItemsToShow, isBlogListingPage = props.isBlogListingPage, isTestimonialListingPage = props.isTestimonialListingPage;
    var ref1 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), previewDevice = ref1.widgetContextState.previewDevice;
    var ref2 = (0,react.useState)({
        showViewAllButton: false,
        areAllItemsVisible: false,
        forCarousel: false
    }), viewAllItemsConfig = ref2[0], setViewAllItemsConfig = ref2[1];
    var isViewAllBtnToShow = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.viewAllItemsButtonConfig) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        return item.isShow;
    });
    (0,react.useEffect)(function() {
        if (isLayoutCarousel) {
            if (contentTypeConditions.featured && !contentTypeConditions.featuredReels) {
                setViewAllItemsConfig({
                    areAllItemsVisible: true,
                    showViewAllButton: true,
                    forCarousel: false
                });
            } else if (contentTypeConditions.testimonials && !isTestimonialListingPage && listPresentationConfig.type !== widgets/* ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */.Pe.PRODUCT_TESTIMONIALS.type) {
                setViewAllItemsConfig({
                    areAllItemsVisible: false,
                    showViewAllButton: true,
                    forCarousel: false
                });
            } else if (contentTypeConditions.instagram) {
                setViewAllItemsConfig({
                    areAllItemsVisible: true,
                    showViewAllButton: isViewAllBtnToShow,
                    forCarousel: false
                });
            } else {
                setViewAllItemsConfig({
                    areAllItemsVisible: true,
                    showViewAllButton: isViewAllBtnToShow || contentTypeConditions.featuredCollection ? !!moreItemsAvailable : false,
                    forCarousel: true
                });
            }
        } else {
            if (contentTypeConditions.blogs && !isBlogListingPage) {
                setViewAllItemsConfig({
                    areAllItemsVisible: true,
                    showViewAllButton: true,
                    forCarousel: false
                });
            } else if (contentTypeConditions.logoSlider) {
                setViewAllItemsConfig({
                    areAllItemsVisible: false,
                    showViewAllButton: false,
                    forCarousel: false
                });
            } else if (contentTypeConditions.testimonials && !isTestimonialListingPage && !contentTypeConditions.productTestimonial) {
                setViewAllItemsConfig({
                    areAllItemsVisible: false,
                    showViewAllButton: true,
                    forCarousel: false
                });
            } else if (contentTypeConditions.instagram) {
                setViewAllItemsConfig({
                    areAllItemsVisible: true,
                    showViewAllButton: isViewAllBtnToShow,
                    forCarousel: false
                });
            } else if (isViewAllBtnToShow) {
                if (contentTypeConditions.featured || contentTypeConditions.collection || contentTypeConditions.category || contentTypeConditions.productTestimonial) {
                    if (numItemsToShow < itemCountTotal) {
                        setViewAllItemsConfig({
                            areAllItemsVisible: false,
                            showViewAllButton: true,
                            forCarousel: false
                        });
                    } else {
                        setViewAllItemsConfig({
                            areAllItemsVisible: true,
                            showViewAllButton: false,
                            forCarousel: false
                        });
                    }
                }
            } else {
                setViewAllItemsConfig({
                    areAllItemsVisible: false,
                    showViewAllButton: false,
                    forCarousel: false
                });
            }
        }
    }, [
        isViewAllBtnToShow,
        itemCountTotal,
        numItemsToShow,
        isLayoutCarousel,
        previewDevice,
        contentTypeConditions,
        moreItemsAvailable, 
    ]);
    return {
        viewAllItemsConfig: viewAllItemsConfig,
        setViewAllItemsConfig: setViewAllItemsConfig
    };
}

// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useLayoutTypes.tsx
var useLayoutTypes = __webpack_require__(98078);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/utils/generalUtils.ts










var useGetLayoutBasedUtilities = function(param) {
    var listPresentationConfig = param.listPresentationConfig, cardFrameConfig = param.cardFrameConfig, isMobile = param.isMobile, contentTypeConditions = param.contentTypeConditions, props = param.props, globalStyle = param.globalStyle, sectionContainerRef = param.sectionContainerRef, itemContainerRef = param.itemContainerRef, itemCountTotal = param.itemCountTotal, moreItemsAvailable = param.moreItemsAvailable, instaUserData = param.instaUserData;
    var getMobilePadding = // Paddings & margin calculations
    // 1
    function getMobilePadding() {
        if (contentTypeConditions.instagram || isProductTestimonials) {
            return 20;
        }
        return 16;
    };
    var ref, ref1, ref2, ref3, ref4;
    var isLayout4 = (0,useLayoutTypes/* useLayoutTypes */.V)({
        listPresentationConfig: listPresentationConfig
    }).isLayout4;
    var isProductTestimonials = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === widgets/* ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */.Pe.PRODUCT_TESTIMONIALS.type;
    var ref5 = (0,react.useState)({
        scrollPercentage: ListPresentationV1_utils/* INITIAL_SCROLL_PERCENTAGE */.Sk,
        overflowSectionCount: 1,
        currentFocusedSectionItem: 1,
        currentFocusedSectionExact: 1,
        direction: "to-right"
    }), carouselIndicatorConfigs = ref5[0], setCarouselIndicatorConfigs = ref5[1];
    var ref6 = (0,ProductListWrapper_utils/* useProductCardElements */.S3)(), productCardAspectRatio = ref6.aspectRatio;
    var ref7 = (0,useAutoScrollOrRotation/* useAutoScrollOrRotation */.o)({
        listPresentationConfig: listPresentationConfig
    }), isAutoRotateEnabled = ref7.isAutoRotateEnabled, autoRotateTimer = ref7.autoRotateTimer;
    var carouselConfigs = globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.carousel) === null || ref === void 0 ? void 0 : ref.config;
    var isLayoutCarousel = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel" && !(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.autoScroll);
    var aspectRatio = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.aspectRatio) || "1:1";
    var sectionColors = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref1 = listPresentationConfig.colors) === null || ref1 === void 0 ? void 0 : (ref3 = ref1.colorSchemes) === null || ref3 === void 0 ? void 0 : ref3[listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref2 = listPresentationConfig.colors) === null || ref2 === void 0 ? void 0 : ref2.selectedColorSchemeIndex];
    var isMoveableHeading = (contentTypeConditions === null || contentTypeConditions === void 0 ? void 0 : contentTypeConditions.instagram) && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName) === constant/* LAYOUT_TYPE.layout3 */.yP.layout3;
    var instaHandleProps = contentTypeConditions.instagram ? {
        showInstaHandle: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.showInstaHandle,
        instaHandle: (instaUserData === null || instaUserData === void 0 ? void 0 : (ref4 = instaUserData.user) === null || ref4 === void 0 ? void 0 : ref4.username) || "",
        instaHandlePosition: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.instaHandlePosition
    } : {};
    var featuredReelConfigs = {
        expandFocusedReel: isMobile && contentTypeConditions.featuredReels && (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.mobileEnlargeAndFocus)
    };
    // Returns number of columns & rows
    var containerTracks = (0,ListPresentationV1_utils/* getContainerTracks */.sR)({
        isLayoutCarousel: isLayoutCarousel,
        itemCount: itemCountTotal,
        isMobile: isMobile,
        listPresentationConfig: listPresentationConfig,
        expandSelectedReel: featuredReelConfigs.expandFocusedReel,
        isTestimonials: contentTypeConditions.testimonials
    });
    // Item gaps
    var gridGapAxis = (0,ListPresentationV1_utils/* getGridGapsForAxes */.KH)({
        isMobile: isMobile,
        cardFrameConfig: cardFrameConfig,
        listPresentationConfig: listPresentationConfig,
        type: listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type,
        isLayoutTypeCard: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.appearance) === "card",
        expandSelectedReel: featuredReelConfigs.expandFocusedReel,
        numColumns: containerTracks.numColumnsOriginal
    });
    var containerHorizontalPadding = !isMobile ? 40 : !isLayoutCarousel ? getMobilePadding() : 0;
    var contentHorizontalPadding = !containerHorizontalPadding ? !isMobile ? 40 : contentTypeConditions.testimonials ? 10 : 20 : 0;
    // 2
    var listHorizontalPadding = isLayoutCarousel && isMobile && !(contentTypeConditions.gallery && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName) !== Constants/* COMMON_LAYOUT_TYPE.TWO */.o_.TWO) ? contentTypeConditions.testimonials ? 10 : 20 : 0;
    var listVerticalPadding = 0;
    var isCardScaleAnimation = (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType) === "zoomInCard" && !isMobile || (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.mobileEnlargeAndFocus) && isMobile;
    if (isCardScaleAnimation) {
        listVerticalPadding += 20;
        listHorizontalPadding += 20;
    }
    // Section Width calculations
    var SECTION_WIDTH = !checkRenderEnv/* IS_SERVER */.W6 ? (sectionContainerRef === null || sectionContainerRef === void 0 ? void 0 : sectionContainerRef.clientWidth) - ((props === null || props === void 0 ? void 0 : props.isBlogListingPage) ? 0 : containerHorizontalPadding * 2) : isMobile ? 480 : 720;
    var showCarouselIndicators = function() {
        var areUsableLayouts = !contentTypeConditions.testimonials || contentTypeConditions.testimonials && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName) !== Constants/* COMMON_LAYOUT_TYPE.FOUR */.o_.FOUR;
        var isWidthCorrect = (itemContainerRef === null || itemContainerRef === void 0 ? void 0 : itemContainerRef.clientWidth) < (itemContainerRef === null || itemContainerRef === void 0 ? void 0 : itemContainerRef.scrollWidth);
        return isLayoutCarousel && areUsableLayouts && isWidthCorrect;
    }();
    var showArrow = isLayoutCarousel ? isMobile ? (carouselConfigs === null || carouselConfigs === void 0 ? void 0 : carouselConfigs.showArrowInMobile) && showCarouselIndicators : showCarouselIndicators : false;
    var slideOffsetMultiplier = {
        forWidth: isMobile || contentTypeConditions.testimonials && containerTracks.numColumns === 1 ? 1 : 2,
        forGap: isMobile || contentTypeConditions.testimonials && containerTracks.numColumns === 1 ? 1 : 2
    };
    // Remaining width from section after removing gaps & x-padding
    var cardContainerWidthForEachCell = SECTION_WIDTH + gridGapAxis.columnGap - containerTracks.numColumns * gridGapAxis.columnGap - 2 * listHorizontalPadding;
    // For carousel: Remove some width from columns to partially show the next one i.e.
    // reduce width slightly for each card so that an overflowed card is shown slightly to nudge the user to scroll
    var widthAdditionals = !contentTypeConditions.testimonials ? isLayoutCarousel && itemCountTotal > containerTracks.numColumns && isMobile ? -containerTracks.numColumns * 6 : 0 : 0;
    // Width for each column (product item)
    var oneGridCellGeometry = (0,ListPresentationV1_utils/* getOneCellGeometry */.dE)({
        cardContainerWidthForEachCell: cardContainerWidthForEachCell,
        containerTracks: containerTracks,
        aspectRatio: !contentTypeConditions.featured || contentTypeConditions.featuredReels ? aspectRatio : productCardAspectRatio,
        widthAdditionals: widthAdditionals,
        type: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) || "",
        isMobile: isMobile,
        isLayoutTypeCard: (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.appearance) === "card"
    });
    var slideOffset = oneGridCellGeometry.width * slideOffsetMultiplier.forWidth + gridGapAxis.columnGap * slideOffsetMultiplier.forGap;
    var columns = isMobile ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.numColumnsMobile : listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.numColumnsDesktop;
    var showAutoRotation = isLayoutCarousel && isAutoRotateEnabled && autoRotateTimer && itemCountTotal > columns;
    var columnWidthShift = oneGridCellGeometry.width + gridGapAxis.columnGap;
    var shouldAutoScrollSlider = (0,ListPresentationV1_utils/* isLogoSliderAutoScroll */.F8)({
        cardFrameConfig: cardFrameConfig,
        listPresentationConfig: listPresentationConfig
    });
    var isSliderFullWidth = (0,ListPresentationV1_utils/* checkIsSliderFullWidth */.ND)({
        cardFrameConfig: cardFrameConfig,
        listPresentationConfig: listPresentationConfig
    });
    var numItemsToShow = containerTracks.numColumns * containerTracks.numRows;
    var ref8 = useSetViewAllBtnConfig({
        contentTypeConditions: contentTypeConditions,
        isLayoutCarousel: isLayoutCarousel,
        listPresentationConfig: listPresentationConfig,
        moreItemsAvailable: moreItemsAvailable,
        itemCountTotal: itemCountTotal,
        numItemsToShow: numItemsToShow,
        isBlogListingPage: props === null || props === void 0 ? void 0 : props.isBlogListingPage,
        isTestimonialListingPage: props === null || props === void 0 ? void 0 : props.isTestimonialListingPage
    }), viewAllItemsConfig = ref8.viewAllItemsConfig, setViewAllItemsConfig = ref8.setViewAllItemsConfig;
    var getConfigsAndUtils = function() {
        var showAuthorImageList = (contentTypeConditions.testimonials || contentTypeConditions.productTestimonial) && isLayout4 && !!itemCountTotal;
        return {
            generalValues: {
                numItemsToShow: numItemsToShow,
                isSliderFullWidth: isSliderFullWidth,
                oneGridCellGeometry: oneGridCellGeometry,
                cardContainerWidthForEachCell: cardContainerWidthForEachCell,
                isCardScaleAnimation: isCardScaleAnimation,
                sectionColors: sectionColors,
                viewAllItemsConfig: viewAllItemsConfig,
                showAuthorImageList: showAuthorImageList,
                shouldAutoScrollSlider: shouldAutoScrollSlider,
                columnWidthShift: columnWidthShift,
                showAutoRotation: showAutoRotation,
                columns: columns,
                slideOffset: slideOffset,
                widthAdditionals: widthAdditionals,
                slideOffsetMultiplier: slideOffsetMultiplier,
                showArrow: showArrow,
                showCarouselIndicators: showCarouselIndicators,
                contentHorizontalPadding: contentHorizontalPadding,
                gridGapAxis: gridGapAxis,
                containerTracks: containerTracks,
                autoRotateTimer: autoRotateTimer,
                carouselConfigs: carouselConfigs,
                isLayout4: isLayout4,
                featuredReelConfigs: featuredReelConfigs,
                isTestimonialListingPage: props === null || props === void 0 ? void 0 : props.isTestimonialListingPage,
                carouselIndicatorConfigs: carouselIndicatorConfigs,
                isLayoutCarousel: isLayoutCarousel,
                listVerticalPadding: listVerticalPadding,
                listHorizontalPadding: listHorizontalPadding,
                containerHorizontalPadding: containerHorizontalPadding,
                isMoveableHeading: isMoveableHeading,
                instaHandleProps: instaHandleProps
            },
            setters: {
                setViewAllItemsConfig: setViewAllItemsConfig,
                setCarouselIndicatorConfigs: setCarouselIndicatorConfigs
            }
        };
    };
    return {
        getConfigsAndUtils: getConfigsAndUtils
    };
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/hooks/useResetLayoutScroll.ts

// Builder specific reset scroll position on changing layout
function useResetLayoutScroll(param) {
    var itemContainerRef = param.itemContainerRef, listPresentationConfig = param.listPresentationConfig, columns = param.columns, isMobile = param.isMobile;
    (0,react.useEffect)(function() {
        if (itemContainerRef) {
            itemContainerRef.scrollTo(0, 0);
        }
    }, [
        itemContainerRef,
        listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName,
        columns,
        isMobile
    ]);
    return null;
}

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/utils/getElementsToMap.tsx

var InstagramReels = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2004), __webpack_require__.e(1087), __webpack_require__.e(9912)]).then(__webpack_require__.bind(__webpack_require__, 121910)).then(function(mod) {
        return mod.InstagramReels;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(121910)
            ];
        }
    }
});
var Testimonials = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(437), __webpack_require__.e(6095), __webpack_require__.e(6151)]).then(__webpack_require__.bind(__webpack_require__, 732090)).then(function(mod) {
        return mod.Testimonials;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(732090)
            ];
        }
    }
});
var ListDescriptionSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4505), __webpack_require__.e(4474)]).then(__webpack_require__.bind(__webpack_require__, 324474)).then(function(mod) {
        return mod.ListDescriptionSection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(324474)
            ];
        }
    }
});
var Reels = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3458).then(__webpack_require__.bind(__webpack_require__, 923458)).then(function(mod) {
        return mod.Reels;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(923458)
            ];
        }
    }
});
var BlogHeroPage = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9855).then(__webpack_require__.bind(__webpack_require__, 979855)).then(function(mod) {
        return mod.BlogHeroPage;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(979855)
            ];
        }
    }
});
var LogoSliderRenderer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2103).then(__webpack_require__.bind(__webpack_require__, 702103));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(702103)
            ];
        }
    }
});
var GalleryWidget = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2693).then(__webpack_require__.bind(__webpack_require__, 172693));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(172693)
            ];
        }
    }
});
var ProductCardRenderer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9247).then(__webpack_require__.bind(__webpack_require__, 749247));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(749247)
            ];
        }
    }
});
var MultiColumnRenderer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(373), __webpack_require__.e(666), __webpack_require__.e(3872)]).then(__webpack_require__.bind(__webpack_require__, 990269));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(990269)
            ];
        }
    }
});
var BlogWidgetRenderer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1068).then(__webpack_require__.bind(__webpack_require__, 261068));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(261068)
            ];
        }
    }
});
var AuthorImageList = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6095), __webpack_require__.e(6513)]).then(__webpack_require__.bind(__webpack_require__, 526197));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(526197)
            ];
        }
    }
});
var CarouselIndicator = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4505).then(__webpack_require__.bind(__webpack_require__, 254505));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(254505)
            ];
        }
    }
});
var ViewMoreButton = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3935).then(__webpack_require__.bind(__webpack_require__, 293935));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(293935)
            ];
        }
    }
});
function getElementsToMap(param) {
    var contentTypeConditions = param.contentTypeConditions, showAuthorImageList = param.showAuthorImageList, viewAllItemsConfig = param.viewAllItemsConfig, props = param.props;
    var elementsToMap = {
        header: [],
        body: [],
        footer: []
    };
    // Push Header elements
    elementsToMap.header.push({
        Component: ListDescriptionSection,
        props: {}
    });
    if (props === null || props === void 0 ? void 0 : props.isBlogListingPage) {
        elementsToMap.header.push({
            Component: BlogHeroPage,
            props: {}
        });
    }
    if (contentTypeConditions.testimonials || contentTypeConditions.productTestimonial) {
        elementsToMap.body.push({
            Component: Testimonials,
            props: {}
        });
    } else if (contentTypeConditions.featuredReels) {
        elementsToMap.body.push({
            Component: Reels,
            props: {}
        });
    } else if (contentTypeConditions.logoSlider) {
        elementsToMap.body.push({
            Component: LogoSliderRenderer,
            props: {}
        });
    } else if (contentTypeConditions.blogs) {
        elementsToMap.body.push({
            Component: BlogWidgetRenderer,
            props: {}
        });
    } else if (contentTypeConditions.gallery) {
        elementsToMap.body.push({
            Component: GalleryWidget,
            props: {}
        });
    } else if (contentTypeConditions.multiColumn) {
        elementsToMap.body.push({
            Component: MultiColumnRenderer,
            props: {}
        });
    } else if (contentTypeConditions.instagram) {
        elementsToMap.body.push({
            Component: InstagramReels,
            props: {}
        });
    } else {
        elementsToMap.body.push({
            Component: ProductCardRenderer,
            props: {}
        });
    }
    // Push footer elements
    if (viewAllItemsConfig.forCarousel) {
        elementsToMap.footer.push({
            Component: ViewMoreButton,
            props: {}
        });
    }
    if ((contentTypeConditions.testimonials || contentTypeConditions.productTestimonial) && showAuthorImageList) {
        elementsToMap.footer.push({
            Component: AuthorImageList,
            props: {}
        });
    }
    elementsToMap.footer.push({
        Component: CarouselIndicator,
        props: {}
    });
    if (!viewAllItemsConfig.forCarousel) {
        elementsToMap.footer.push({
            Component: ViewMoreButton,
            props: {}
        });
    }
    return {
        elementsToMap: elementsToMap
    };
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/useListPresentationData.tsx








/** This file has all calculation & mutations of data globally to be available in the ListPresentation component
 * rendered on CFE */ function useListPresentationData() {
    var setProps = function setProps(_props) {
        if (!isBuilder) {
            propsRef.current = _props;
        } else setPropsState(_props);
    };
    var ref, ref1;
    // Props
    // Used on cfe as this data is present even before rendering & is unchanging so no state setter is required
    var propsRef = (0,react.useRef)({});
    // Used on builder as this data is keeps changing & is not required as server side data
    var ref2 = (0,react.useState)({}), propsState = ref2[0], setPropsState = ref2[1];
    // States
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref3.widgetContextState, isBuilder = _widgetContextState.isBuilder, previewDevice = _widgetContextState.previewDevice, globalStyle = _widgetContextState.globalStyle, instaUserData = _widgetContextState.instaUserData;
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = isBuilder ? previewDevice === "mobile" : deviceType === "mobile";
    // Variables
    var props = !isBuilder ? propsRef.current : propsState;
    var listPresentationConfig = (props === null || props === void 0 ? void 0 : (ref = props.widgetOptions) === null || ref === void 0 ? void 0 : ref.listPresentation) || {};
    var cardFrameConfig = (props === null || props === void 0 ? void 0 : (ref1 = props.widgetOptions) === null || ref1 === void 0 ? void 0 : ref1.cardFrame) || {};
    var ref4 = useGetItemsToIterate({
        cardFrameConfig: cardFrameConfig,
        props: props,
        listPresentationConfig: listPresentationConfig,
        instaUserData: instaUserData
    }), iterableList = ref4.iterableList, contentTypeConditions = ref4.contentTypeConditions, moreItemsAvailable = ref4.moreItemsAvailable;
    var itemCountTotal = iterableList === null || iterableList === void 0 ? void 0 : iterableList.length;
    var ref5 = useRefSetters(), sectionContainerRefSetter = ref5.sectionContainerRefSetter, itemsContainerRefSetter = ref5.itemsContainerRefSetter, sectionContainerRef = ref5.sectionContainerRef, itemContainerRef = ref5.itemContainerRef;
    var getConfigsAndUtils = useGetLayoutBasedUtilities({
        listPresentationConfig: listPresentationConfig,
        cardFrameConfig: cardFrameConfig,
        isMobile: isMobile,
        contentTypeConditions: contentTypeConditions,
        props: props,
        globalStyle: globalStyle,
        sectionContainerRef: sectionContainerRef,
        itemContainerRef: itemContainerRef,
        itemCountTotal: itemCountTotal,
        moreItemsAvailable: moreItemsAvailable,
        instaUserData: instaUserData
    }).getConfigsAndUtils;
    // Builder only
    useResetLayoutScroll({
        itemContainerRef: itemContainerRef,
        listPresentationConfig: listPresentationConfig,
        columns: getConfigsAndUtils().generalValues.columns,
        isMobile: isMobile
    });
    var elementsToMap = getElementsToMap({
        contentTypeConditions: contentTypeConditions,
        showAuthorImageList: getConfigsAndUtils().generalValues.showAuthorImageList,
        viewAllItemsConfig: getConfigsAndUtils().generalValues.viewAllItemsConfig,
        props: props
    }).elementsToMap;
    return {
        internalData: {
            utilities: {
                setProps: setProps
            }
        },
        externalData: {
            state: {
                listPresentationConfig: listPresentationConfig,
                cardFrameConfig: cardFrameConfig,
                isMobile: isMobile,
                moreItemsAvailable: moreItemsAvailable,
                iterableList: iterableList,
                itemCountTotal: itemCountTotal,
                contentTypeConditions: contentTypeConditions
            },
            elementsToMap: elementsToMap,
            refs: {
                sectionContainerRef: sectionContainerRef,
                itemContainerRef: itemContainerRef
            },
            refSetters: {
                sectionContainerRefSetter: sectionContainerRefSetter,
                itemsContainerRefSetter: itemsContainerRefSetter
            },
            utilities: {
                getConfigsAndUtils: getConfigsAndUtils
            },
            props: props
        }
    };
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useSetScrollSections.ts





function useSetScrollSections() {
    var data = useListPresentationContextData();
    var _state = data.state, isMobile = _state.isMobile, contentTypeConditions = _state.contentTypeConditions, iterableList = _state.iterableList, isLayoutCarousel = _state.isLayoutCarousel, listPresentationConfig = _state.listPresentationConfig;
    var itemContainerRef = data.refs.itemContainerRef;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, slideOffsetMultiplier = _generalValues.slideOffsetMultiplier, containerTracks = _generalValues.containerTracks;
    var setCarouselIndicatorConfigs = getConfigsAndUtils().setters.setCarouselIndicatorConfigs;
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), previewDevice = ref.widgetContextState.previewDevice;
    (0,react.useEffect)(function() {
        if (itemContainerRef && (iterableList === null || iterableList === void 0 ? void 0 : iterableList.length)) {
            setTimeout(function() {
                var ref = itemContainerRef || {}, clientWidth = ref.clientWidth, scrollWidth = ref.scrollWidth;
                var sectionScrollWidth = Math.ceil(contentTypeConditions.testimonials ? scrollWidth / clientWidth : ((iterableList === null || iterableList === void 0 ? void 0 : iterableList.length) - containerTracks.numColumns) / slideOffsetMultiplier.forWidth + (!isMobile ? 1 : 0));
                if (scrollWidth > clientWidth) {
                    setCarouselIndicatorConfigs(function(data) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            overflowSectionCount: sectionScrollWidth,
                            // overflowSectionCount: Math.ceil(scrollWidth / clientWidth),
                            currentFocusedSectionItem: 1
                        });
                    });
                }
            }, 100);
        }
    }, [
        iterableList,
        isLayoutCarousel,
        isMobile,
        listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.progressIndicator,
        previewDevice,
        containerTracks.numColumns,
        slideOffsetMultiplier.forWidth,
        itemContainerRef,
        contentTypeConditions.testimonials, 
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useAutoRotation.ts



function useAutoRotation() {
    var startAutoRotation = function startAutoRotation() {
        if (itemContainerRef && showAutoRotation) {
            var scrollContainer = itemContainerRef;
            interval.current = setInterval(function() {
                var remainingShiftForward = (0,ListPresentationV1_utils/* getShift */.$O)(itemContainerRef, showAutoRotation, slideOffset, columnWidthShift).remainingShiftForward;
                scrollContainer.scrollTo({
                    left: scrollContainer.scrollLeft + remainingShiftForward,
                    behavior: isLayout4 ? "instant" : "smooth"
                });
                var repeatitionStarted = Math.ceil(scrollContainer.scrollLeft) >= Math.floor(columnWidthShift * (itemCountTotal - (isLayout4 ? 0 : 1)));
                if (repeatitionStarted) {
                    setTimeout(switchToInitialState, 1500);
                }
            }, autoRotateTimer * 1000);
        }
    };
    var switchToInitialState = function switchToInitialState() {
        if (itemContainerRef) {
            itemContainerRef.scrollTo({
                left: 0,
                behavior: "instant"
            });
        }
    };
    var stopAutoRotation = function stopAutoRotation() {
        if (interval.current) {
            clearInterval(interval.current);
            interval.current = null;
        }
    };
    var interval = (0,react.useRef)(null);
    var data = useListPresentationContextData();
    var _state = data.state, isMobile = _state.isMobile, itemCountTotal = _state.itemCountTotal, contentTypeConditions = _state.contentTypeConditions;
    var itemContainerRef = data.refs.itemContainerRef;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, columnWidthShift = _generalValues.columnWidthShift, showAutoRotation = _generalValues.showAutoRotation, columns = _generalValues.columns, slideOffset = _generalValues.slideOffset, gridGapAxis = _generalValues.gridGapAxis, autoRotateTimer = _generalValues.autoRotateTimer, isLayout4 = _generalValues.isLayout4;
    // handle auto rotation
    (0,react.useEffect)(function() {
        startAutoRotation();
        return function() {
            stopAutoRotation();
            contentTypeConditions.testimonials && switchToInitialState();
        };
    }, [
        itemCountTotal,
        showAutoRotation,
        autoRotateTimer,
        gridGapAxis.columnGap,
        columns,
        columnWidthShift,
        isMobile, 
    ]);
    return {
        stopAutoRotation: stopAutoRotation,
        startAutoRotation: startAutoRotation
    };
}

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/components/LayoutWrapper/index.tsx









function LayoutWrapper(param) {
    var children = param.children;
    var handleHeadingClick = function handleHeadingClick() {
        if ((contentTypeConditions.multiColumn || contentTypeConditions.logoSlider || contentTypeConditions.testimonials || contentTypeConditions.gallery) && isBuilder) {
            handleWidgetPropChange({
                subWidget: "",
                subWidgetIndex: -1
            }, activeWidgetId);
        }
    };
    var getSectionStyles = function getSectionStyles() {
        var ref, ref1;
        return (0,_object_spread/* default */.Z)({
            padding: (props === null || props === void 0 ? void 0 : props.isBlogListingPage) ? 0 : "".concat(containerVerticalPadding, "px ").concat(isSliderFullWidth ? 0 : containerHorizontalPadding, "px"),
            margin: "".concat(containerTopMargin, "px ").concat(isSliderFullWidth ? "" : "auto", " ").concat(containerBottomMargin, "px ").concat(isSliderFullWidth ? "" : "auto"),
            maxWidth: isSliderFullWidth ? "100vw" : "".concat((props === null || props === void 0 ? void 0 : props.isBlogListingPage) ? ListPresentationV1_utils/* BLOG_SECTION_MAX_WIDTH */.Ku : ListPresentationV1_utils/* MAX_SECTION_WIDTH */.ZO, "px")
        }, ((ref = props.overrides) === null || ref === void 0 ? void 0 : (ref1 = ref.layout) === null || ref1 === void 0 ? void 0 : ref1.styles) || {});
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var data = useListPresentationContextData();
    var props = data.props;
    var _state = data.state, cardFrameConfig = _state.cardFrameConfig, listPresentationConfig = _state.listPresentationConfig, isMobile = _state.isMobile, contentTypeConditions = _state.contentTypeConditions;
    var sectionContainerRefSetter = data.refSetters.sectionContainerRefSetter;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, shouldAutoScrollSlider = _generalValues.shouldAutoScrollSlider, isSliderFullWidth = _generalValues.isSliderFullWidth, containerHorizontalPadding = _generalValues.containerHorizontalPadding, sectionColors = _generalValues.sectionColors;
    var ref6 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref6.widgetContextState, activeWidgetId = _widgetContextState.activeWidgetId, isBuilder = _widgetContextState.isBuilder, handleWidgetPropChange = ref6.widgetContextHelpers.handleWidgetPropChange;
    var containerVerticalPadding = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig[!isMobile ? "paddingY" : "mobilePaddingY"]) || 0;
    var containerTopMargin = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.marginTop;
    var containerBottomMargin = listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.marginBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("listPresentationContainer", (props === null || props === void 0 ? void 0 : props.isTestimonialListingPage) ? "tw-mx-auto tw-max-w-[1200px]" : ""),
        style: {
            background: typeof ((ref = props.overrides) === null || ref === void 0 ? void 0 : (ref1 = ref.layout) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.styles) === null || ref2 === void 0 ? void 0 : ref2.background) === "string" ? (ref3 = props.overrides) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.layout) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.styles) === null || ref5 === void 0 ? void 0 : ref5.background : sectionColors === null || sectionColors === void 0 ? void 0 : sectionColors.background
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            ref: sectionContainerRefSetter,
            className: classnames_default()("".concat((cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.contentAlignment) !== "left" ? !shouldAutoScrollSlider ? "tw-items-center" : "" : "", " tw-flex tw-w-[100%] tw-flex-col")),
            style: getSectionStyles(),
            onClick: handleHeadingClick,
            children: children
        })
    });
}
function LayoutBodyWrapper(param) {
    var children = param.children;
    var getCardContainerClass = function getCardContainerClass() {
        return classnames_default()("no-scrollbar tw-max-w-[100%] tw-overscroll-x-none tw-flex-shrink-0", (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.contentAlignment) !== "left" && !(props === null || props === void 0 ? void 0 : props.isBlogListingPage) ? !shouldAutoScrollSlider ? contentTypeConditions.gallery && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName) === Constants/* COMMON_LAYOUT_TYPE.THREE */.o_.THREE ? "tw-w-[100%]" : "tw-mx-auto" : "" : "", !isLayoutCarousel ? "tw-grid" : "tw-flex tw-items-stretch", (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel" && contentTypeConditions.logoSlider && !shouldAutoScrollSlider ? "!tw-pb-[15px] !tw-pt-[35px] ".concat(isMobile ? "!tw-px-[16px]" : "") : "");
    };
    var getCardContainerStyles = function getCardContainerStyles() {
        var style = {};
        if (!isLayoutCarousel) {
            style.gridTemplateColumns = "repeat(".concat((viewAllItemsConfig === null || viewAllItemsConfig === void 0 ? void 0 : viewAllItemsConfig.areAllItemsVisible) ? "auto-fit" : containerTracks === null || containerTracks === void 0 ? void 0 : containerTracks.numColumnsMax, ", ").concat(oneGridCellGeometry.width, "px)");
            if (!(viewAllItemsConfig === null || viewAllItemsConfig === void 0 ? void 0 : viewAllItemsConfig.areAllItemsVisible)) {
                style.gridTemplateRows = "repeat(".concat(containerTracks === null || containerTracks === void 0 ? void 0 : containerTracks.numRows, ", auto)");
            }
            for(var key in gridGapAxis){
                if (key) {
                    style[key] = gridGapAxis[key];
                }
            }
        } else {
            style.overflowX = "auto";
            style.gap = gridGapAxis.columnGap;
        }
        style.overflowY = contentTypeConditions.featured && !contentTypeConditions.featuredReels ? "hidden" : "visible";
        style.padding = "".concat(listVerticalPadding, "px ").concat(listHorizontalPadding, "px");
        if (isCardScaleAnimation) {
            style.marginBottom = "-20px";
            style.marginTop = "-20px";
        }
        if (featuredReelConfigs.expandFocusedReel) {
            style.paddingLeft = "calc(50% - ".concat(oneGridCellGeometry.width / 2, "px)");
            style.paddingRight = "calc(50% - ".concat(oneGridCellGeometry.width / 2, "px)");
            style.scrollSnapType = "x mandatory";
        }
        if (isProductTestimonials && isLayoutCarousel) {
            style.padding = "0 20px";
        }
        if (contentTypeConditions.instagram) {
            if (isLayoutCarousel) {
                style.padding = (0,ListPresentationV1_utils/* getPaddingForInstaWidget */.Fs)(listPresentationConfig, isMobile);
            } else {
                style.padding = 0;
                style.margin = 0;
            }
        }
        return style;
    };
    var data = useListPresentationContextData();
    var props = data.props;
    var _state = data.state, cardFrameConfig = _state.cardFrameConfig, contentTypeConditions = _state.contentTypeConditions, listPresentationConfig = _state.listPresentationConfig, isMobile = _state.isMobile;
    var itemsContainerRefSetter = data.refSetters.itemsContainerRefSetter;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, slideOffset = _generalValues.slideOffset, widthAdditionals = _generalValues.widthAdditionals, shouldAutoScrollSlider = _generalValues.shouldAutoScrollSlider, isLayoutCarousel = _generalValues.isLayoutCarousel, containerTracks = _generalValues.containerTracks, viewAllItemsConfig = _generalValues.viewAllItemsConfig, gridGapAxis = _generalValues.gridGapAxis, listVerticalPadding = _generalValues.listVerticalPadding, listHorizontalPadding = _generalValues.listHorizontalPadding, isCardScaleAnimation = _generalValues.isCardScaleAnimation, featuredReelConfigs = _generalValues.featuredReelConfigs, oneGridCellGeometry = _generalValues.oneGridCellGeometry;
    var setCarouselIndicatorConfigs = getConfigsAndUtils().setters.setCarouselIndicatorConfigs;
    var isProductTestimonials = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === widgets/* ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */.Pe.PRODUCT_TESTIMONIALS.type;
    /** This renders card columns either as carousel or grid */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: getCardContainerClass(),
        style: getCardContainerStyles(),
        ref: itemsContainerRefSetter,
        onScroll: function(e) {
            return (0,ListPresentationV1_utils/* onCarouselScroll */.ns)({
                e: e,
                setCarouselIndicatorConfigs: setCarouselIndicatorConfigs,
                slideOffset: slideOffset,
                widthOffset: widthAdditionals
            });
        },
        children: children
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/hooks/useAdjustSubWidgetProps.ts




function useAdjustSubWidgetProps(param) {
    var stopAutoRotation = param.stopAutoRotation, carouselScrollTo = param.carouselScrollTo;
    var adjustWidgetProps = function adjustWidgetProps() {
        var ref;
        if (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.autoPlayConfig) === null || ref === void 0 ? void 0 : ref.type) {
            listPresentationConfig.autoPlayConfig.type = Constants/* SCROLL_TYPE.MANUAL */.ej.MANUAL;
        }
    };
    var removeAdjustedPropChange = function removeAdjustedPropChange() {
        var ref;
        if ((listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.autoPlayConfig) === null || ref === void 0 ? void 0 : ref.type) && oldScrolType) {
            listPresentationConfig.autoPlayConfig.type = oldScrolType;
            setOldScrollType(null);
        }
    };
    var scrollToActiveSubwidget = function scrollToActiveSubwidget() {
        setTimeout(function() {
            return carouselScrollTo(activeSubwidgetIndex);
        }, 0);
    };
    var ref, ref1;
    var data = useListPresentationContextData();
    var props = data.props;
    var listPresentationConfig = data.state.listPresentationConfig;
    var ref2 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref2.widgetContextState, activeWidgetId = _widgetContextState.activeWidgetId, widgets = _widgetContextState.widgets;
    var ref3 = (0,react.useState)(null), oldScrolType = ref3[0], setOldScrollType = ref3[1];
    var activeSubwidgetIndex = widgets === null || widgets === void 0 ? void 0 : (ref = widgets[activeWidgetId]) === null || ref === void 0 ? void 0 : (ref1 = ref.props) === null || ref1 === void 0 ? void 0 : ref1.subWidgetIndex;
    var isSubwidgetSelected = (props === null || props === void 0 ? void 0 : props.id) === activeWidgetId && activeSubwidgetIndex !== -1;
    (0,react.useEffect)(function() {
        if (isSubwidgetSelected) {
            var ref;
            setOldScrollType(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.autoPlayConfig) === null || ref === void 0 ? void 0 : ref.type);
            adjustWidgetProps();
            scrollToActiveSubwidget();
            stopAutoRotation();
        } else {
            removeAdjustedPropChange();
        }
    }, [
        isSubwidgetSelected
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/ListPresentationMain.tsx











var QuickViewModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7856), __webpack_require__.e(9228), __webpack_require__.e(4429), __webpack_require__.e(526), __webpack_require__.e(8557), __webpack_require__.e(1788), __webpack_require__.e(5684), __webpack_require__.e(3333)]).then(__webpack_require__.bind(__webpack_require__, 75684)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75684)
            ];
        }
    }
});
function ListPresentationMain() {
    var data = useListPresentationContextData();
    var props = data.props;
    var ref = useAutoRotation(), stopAutoRotation = ref.stopAutoRotation, startAutoRotation = ref.startAutoRotation;
    var ref1 = (0,ListPresentationV1_utils/* useGetArrowMethods */.uq)(stopAutoRotation, startAutoRotation), onNextArrowClick = ref1.onNextArrowClick, onPrevArrowClick = ref1.onPrevArrowClick, carouselScrollTo = ref1.carouselScrollTo;
    useAdjustSubWidgetProps({
        stopAutoRotation: stopAutoRotation,
        carouselScrollTo: carouselScrollTo
    });
    useSetScrollSections();
    if (props.isVisible === false) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LayoutWrapper, {
        children: [
            data.elementsToMap.header.map(function(param) {
                var Component = param.Component, props = param.props;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    onNextArrowClick: onNextArrowClick,
                    onPrevArrowClick: onPrevArrowClick
                }), Component.name);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutBodyWrapper, {
                children: data.elementsToMap.body.map(function(param) {
                    var Component = param.Component, props = param.props;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props), Component.name);
                })
            }),
            data.elementsToMap.footer.map(function(param) {
                var Component = param.Component, props = param.props;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    carouselScrollTo: carouselScrollTo,
                    onPrevArrowClick: function() {
                        return onPrevArrowClick();
                    },
                    onNextArrowClick: function() {
                        return onNextArrowClick();
                    }
                }), Component.name);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickViewModal, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/ListPresentationWrapper.tsx


// This is ListPresentation wrapper that wraps main component in a context
function ListPresentationWrapper() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListPresentationMain, {});
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentationV1/context/ListPresentationContext.tsx





var LIST_PRESENTATION_INITIAL_DATA = {
    state: {
        listPresentationConfig: {},
        cardFrameConfig: {},
        isMobile: false,
        moreItemsAvailable: false,
        itemCountTotal: 0,
        contentTypeConditions: {},
        iterableList: [],
        featuredReelConfigs: {},
        isLayoutCarousel: false
    },
    refSetters: {},
    refs: {},
    utilities: {
        getConfigsAndUtils: function() {
            return {
                generalValues: {},
                setters: {
                    setViewAllItemsConfig: function() {},
                    setCarouselIndicatorConfigs: function() {}
                }
            };
        }
    },
    props: {},
    elementsToMap: {
        header: [],
        body: [],
        footer: []
    }
};
var ListPresentationContextCreator = /*#__PURE__*/ (0,react.createContext)(LIST_PRESENTATION_INITIAL_DATA);
var ListPresentationContext = /*#__PURE__*/ (0,react.memo)(function ListPresentationCtxComponent(props) {
    var data = useListPresentationData();
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), isBuilder = ref.widgetContextState.isBuilder;
    // const isBuilderRoute = window.location.pathname.includes(PATH.WEBSITE_BUILDER);
    if (!isBuilder) data.internalData.utilities.setProps(props);
    (0,react.useEffect)(function() {
        if (isBuilder) data.internalData.utilities.setProps(props);
    }, [
        props,
        isBuilder
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListPresentationContextCreator.Provider, {
        value: data.externalData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListPresentationWrapper, {})
    });
});
var useListPresentationContextData = function() {
    var data = (0,react.useContext)(ListPresentationContextCreator);
    return data;
};


/***/ }),

/***/ 615030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useAutoScrollOrRotation; }
/* harmony export */ });
/* harmony import */ var _components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26763);

var useAutoScrollOrRotation = function(param) {
    var listPresentationConfig = param.listPresentationConfig;
    var ref, ref1, ref2, ref3;
    var isAutoRotateEnabled = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.autoPlayConfig) === null || ref === void 0 ? void 0 : ref.type) === _components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_0__/* .SCROLL_TYPE.AUTO_ROTATE */ .ej.AUTO_ROTATE;
    var autoRotateTimer = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref1 = listPresentationConfig.autoPlayConfig) === null || ref1 === void 0 ? void 0 : ref1.autoRotateTimer) || 5;
    var isAutoScrollEnabled = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref2 = listPresentationConfig.autoPlayConfig) === null || ref2 === void 0 ? void 0 : ref2.type) === _components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_0__/* .SCROLL_TYPE.AUTO_SCROLL */ .ej.AUTO_SCROLL;
    var autoScrollTimer = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref3 = listPresentationConfig.autoPlayConfig) === null || ref3 === void 0 ? void 0 : ref3.autoplayTimer) || 5;
    return {
        isAutoRotateEnabled: isAutoRotateEnabled,
        autoRotateTimer: autoRotateTimer,
        isAutoScrollEnabled: isAutoScrollEnabled,
        autoScrollTimer: autoScrollTimer
    };
};


/***/ }),

/***/ 98078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useLayoutTypes; }
/* harmony export */ });
var MAX_LAYOUTS = 10;
var LAYOUT_NAME_PREFIX = "layout";
var LAYOUT_KEY_PREFIX = "isLayout";
var useLayoutTypes = function(param) {
    var listPresentationConfig = param.listPresentationConfig;
    var layoutTypes = {};
    for(var layoutNum = 0; layoutNum < MAX_LAYOUTS; layoutNum++){
        var layoutKey = LAYOUT_KEY_PREFIX + layoutNum;
        var layoutName = LAYOUT_NAME_PREFIX + layoutNum;
        layoutTypes[layoutKey] = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutName) === layoutName;
    }
    return layoutTypes;
};


/***/ }),

/***/ 608222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ getShift; },
/* harmony export */   "F8": function() { return /* binding */ isLogoSliderAutoScroll; },
/* harmony export */   "Fs": function() { return /* binding */ getPaddingForInstaWidget; },
/* harmony export */   "JG": function() { return /* binding */ getRenderCardOverrides; },
/* harmony export */   "KH": function() { return /* binding */ getGridGapsForAxes; },
/* harmony export */   "KZ": function() { return /* binding */ getDisplayLabelStyles; },
/* harmony export */   "Ku": function() { return /* binding */ BLOG_SECTION_MAX_WIDTH; },
/* harmony export */   "ND": function() { return /* binding */ checkIsSliderFullWidth; },
/* harmony export */   "Sk": function() { return /* binding */ INITIAL_SCROLL_PERCENTAGE; },
/* harmony export */   "Tf": function() { return /* binding */ getBlogData; },
/* harmony export */   "ZO": function() { return /* binding */ MAX_SECTION_WIDTH; },
/* harmony export */   "dE": function() { return /* binding */ getOneCellGeometry; },
/* harmony export */   "ns": function() { return /* binding */ onCarouselScroll; },
/* harmony export */   "sR": function() { return /* binding */ getContainerTracks; },
/* harmony export */   "uq": function() { return /* binding */ useGetArrowMethods; }
/* harmony export */ });
/* unused harmony exports MAX_CARD_HEIGHT, MAX_CARD_WIDTH, MIN_CARD_WIDTH, MIN_CARD_HEIGHT, MAX_NUM_ROWS_DESKTOP, MAX_NUM_ROWS_MOBILE_ONE_COL, MAX_NUM_ROWS_MOBILE_TWO_COL, MULTI_COLUMN_MIN_WIDTH, MULTI_COLUMN_MIN_WIDTH_MOBILE, MIN_LOGO_SLIDER_CARD_WIDTH, MAX_PRODUCT_REEL_CARD_WIDTH_DESKTOP, MAX_PRODUCT_REEL_CARD_WIDTH_MOBILE, MIN_PRODUCT_REEL_CARD_WIDTH_DESKTOP, MIN_PRODUCT_REEL_CARD_WIDTH_MOBILE, MAX_PRODUCT_REEL_CARD_HEIGHT, MIN_PRODUCT_REEL_CARD_HEIGHT, MAX_LOGO_SLIDER_CARD_WIDTH, MAX_LOGO_SLIDER_HEIGHT, MIN_LOGO_SLIDER_HEIGHT, MAX_PRODUCT_TESTIMONIAL_WIDTH, MAX_PRODUCT_TESTIMONIAL_WIDTH_MOBILR, getCardFrameCustomStyle, getReelCardConfigs, isLogoSliderFullWidth, isTestimonialSliderFullWidth */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var _CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(290331);
/* harmony import */ var _components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26763);
/* harmony import */ var src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(442381);
/* harmony import */ var _context_ListPresentationContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(101657);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_WidgetProperties_ProductTestimonials_ProductTestimonialsConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(766499);
/* harmony import */ var _ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16902);










var MAX_SECTION_WIDTH = 1600;
var BLOG_SECTION_MAX_WIDTH = 1200;
var MAX_CARD_HEIGHT = 680;
var MAX_CARD_WIDTH = 680;
var MIN_CARD_WIDTH = 120; // 170; // 100;
var MIN_CARD_HEIGHT = 120; // 170; // 100;
var MAX_NUM_ROWS_DESKTOP = 2; // 170; // 100;
var MAX_NUM_ROWS_MOBILE_ONE_COL = 4;
var MAX_NUM_ROWS_MOBILE_TWO_COL = 6;
var INITIAL_SCROLL_PERCENTAGE = 20;
var MULTI_COLUMN_MIN_WIDTH = 150;
var MULTI_COLUMN_MIN_WIDTH_MOBILE = 100;
var MIN_LOGO_SLIDER_CARD_WIDTH = 50;
var MAX_PRODUCT_REEL_CARD_WIDTH_DESKTOP = 350;
var MAX_PRODUCT_REEL_CARD_WIDTH_MOBILE = 220;
var MIN_PRODUCT_REEL_CARD_WIDTH_DESKTOP = 172;
var MIN_PRODUCT_REEL_CARD_WIDTH_MOBILE = 150;
var MAX_PRODUCT_REEL_CARD_HEIGHT = 450;
var MIN_PRODUCT_REEL_CARD_HEIGHT = 250;
var MAX_LOGO_SLIDER_CARD_WIDTH = 160;
var MAX_LOGO_SLIDER_HEIGHT = 84;
var MIN_LOGO_SLIDER_HEIGHT = 50;
var MAX_PRODUCT_TESTIMONIAL_WIDTH = 1500;
var MAX_PRODUCT_TESTIMONIAL_WIDTH_MOBILR = 720;
function getNumsOfColumn(isMobile, configData) {
    var ref = configData || {}, numColumnsDesktop = ref.numColumnsDesktop, numColumnsMobile = ref.numColumnsMobile, _mobileImagePosition = ref.mobileImagePosition, mobileImagePosition = _mobileImagePosition === void 0 ? "" : _mobileImagePosition;
    if ((configData === null || configData === void 0 ? void 0 : configData.type) === "blog") {
        return isMobile ? mobileImagePosition === "left" ? 1 : numColumnsMobile : numColumnsDesktop;
    }
    return isMobile ? numColumnsMobile : numColumnsDesktop;
}
// Returns number of columns
function getContainerTracks(param) {
    var isLayoutCarousel = param.isLayoutCarousel, itemCount = param.itemCount, isMobile = param.isMobile, listPresentationConfig = param.listPresentationConfig, _expandSelectedReel = param.expandSelectedReel, expandSelectedReel = _expandSelectedReel === void 0 ? false : _expandSelectedReel, _isTestimonials = param.isTestimonials, isTestimonials = _isTestimonials === void 0 ? false : _isTestimonials;
    var numColumnsOriginal = getNumsOfColumn(isMobile, listPresentationConfig);
    var numColumns = numColumnsOriginal;
    var numColumnsMax = itemCount < numColumns ? itemCount : numColumns;
    if (expandSelectedReel) {
        numColumns = 1;
    }
    var isProductTestimonial = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */ .Pe.PRODUCT_TESTIMONIALS.type;
    // if (!useStaticNumColumns && itemCount < numColumns) {
    //   numColumns = itemCount;
    // }
    var numRowsForGrid = isMobile ? numColumns == 1 ? MAX_NUM_ROWS_MOBILE_ONE_COL : MAX_NUM_ROWS_MOBILE_TWO_COL : MAX_NUM_ROWS_DESKTOP;
    var numRows = isLayoutCarousel ? 1 : numRowsForGrid; // for grid -> 'auto', for carousel -> 1;
    if (numRows > itemCount / numColumns) {
        numRows = Math.ceil(itemCount / numColumns);
    }
    // if testimonial, grid -> max rows -> 2
    if (!isLayoutCarousel && isTestimonials && !isProductTestimonial) {
        numRows = Math.min(2, Math.ceil(itemCount / numColumns));
    }
    return {
        numColumns: numColumns,
        numRows: numRows,
        numColumnsOriginal: numColumnsOriginal,
        numColumnsMax: numColumnsMax
    };
}
function getCardMinMaxWidth(type, isMobile, forType) {
    switch(type){
        case "icon":
        case "image":
            return forType === "max" ? MAX_CARD_WIDTH : isMobile ? MULTI_COLUMN_MIN_WIDTH_MOBILE : MULTI_COLUMN_MIN_WIDTH;
        case "logoSlider":
            return forType === "max" ? MAX_LOGO_SLIDER_CARD_WIDTH : MIN_LOGO_SLIDER_CARD_WIDTH;
        case "featuredReels":
            return forType === "max" ? !isMobile ? MAX_PRODUCT_REEL_CARD_WIDTH_DESKTOP : MAX_PRODUCT_REEL_CARD_WIDTH_MOBILE : !isMobile ? MIN_PRODUCT_REEL_CARD_WIDTH_DESKTOP : MIN_PRODUCT_REEL_CARD_WIDTH_MOBILE;
        case "testimonials":
            return -1;
        case src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS_NAMES.PRODUCT_TESTIMONIAL */ .G.PRODUCT_TESTIMONIAL:
            return forType === "max" ? !isMobile ? MAX_PRODUCT_TESTIMONIAL_WIDTH : MAX_PRODUCT_TESTIMONIAL_WIDTH_MOBILR : MIN_CARD_WIDTH;
        default:
            return forType === "max" ? MAX_CARD_WIDTH : MIN_CARD_WIDTH;
    }
}
function getMaxHeight(type) {
    switch(type){
        case "logoSlider":
            return MAX_LOGO_SLIDER_HEIGHT;
        case "featuredReels":
            return MAX_PRODUCT_REEL_CARD_HEIGHT;
        default:
            return MAX_CARD_HEIGHT;
    }
}
// Width for each column (product item)
function getOneCellGeometry(param) {
    var cardContainerWidthForEachCell = param.cardContainerWidthForEachCell, containerTracks = param.containerTracks, aspectRatio = param.aspectRatio, widthAdditionals = param.widthAdditionals, type = param.type, isMobile = param.isMobile, isLayoutTypeCard = param.isLayoutTypeCard;
    var width = cardContainerWidthForEachCell / containerTracks.numColumns;
    // Reduce width slightly for each card so that an overflowed card is shown slightly to nudge the user to scroll
    width = width + widthAdditionals;
    var minWidth = getCardMinMaxWidth(type, isMobile, "min");
    var maxWidth = getCardMinMaxWidth(type, isMobile, "max");
    if (width > maxWidth && maxWidth > 0) width = maxWidth;
    if (width < minWidth && minWidth > 0) width = minWidth;
    // extract aspect ratio
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(aspectRatio.split(":").map(function(item) {
        return +item;
    }), 2), widthRatio = ref[0], heightRatio = ref[1];
    // calculate height
    var height = width * (heightRatio / widthRatio);
    if (height > getMaxHeight(type)) {
        height = getMaxHeight(type);
        width = ![
            "logoSlider",
            "testimonials",
            src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS_NAMES.PRODUCT_TESTIMONIAL */ .G.PRODUCT_TESTIMONIAL, 
        ].includes(type) ? height * (widthRatio / heightRatio) : width;
    }
    // Meanwhile the width will be used to calculate the normal layout related things because the card will achieve the width
    // as calculated because in case of card layout border width will get added
    return {
        width: width,
        height: height,
        itemWidth: isLayoutTypeCard ? width - 2 // remove horizontal border width as border wil be applied to child of 1px
         : width
    };
}
function getDisplayLabelStyles(configData) {
    var alwaysKeepLeft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var textAlign = configData === null || configData === void 0 ? void 0 : configData.textAlign;
    var styles = {
        alignItems: "",
        width: "100%"
    };
    if (alwaysKeepLeft) {
        styles.alignItems = "flex-start";
        return styles;
    }
    switch(textAlign){
        case "left":
            styles.alignItems = "flex-start";
            break;
        case "center":
            styles.alignItems = "center";
            break;
        default:
            styles.alignItems = "center";
            break;
    }
    return styles;
}
function onCarouselScroll(param) {
    var e = param.e, setCarouselIndicatorConfigs = param.setCarouselIndicatorConfigs, _slideOffset = param.slideOffset, slideOffset = _slideOffset === void 0 ? 0 : _slideOffset, _widthOffset = param.widthOffset, widthOffset = _widthOffset === void 0 ? 0 : _widthOffset;
    var sectionViewportWidth = Math.floor(e.currentTarget.clientWidth);
    var sectionScrollWidth = Math.floor(e.currentTarget.scrollWidth);
    var currentScrollPosition = Math.floor(e.currentTarget.scrollLeft);
    var scrollPercent = currentScrollPosition / (sectionScrollWidth - sectionViewportWidth) * 100;
    // INITIAL_SCROLL_PERCENTAGE move advantage given
    var offsetPosition = scrollPercent * (INITIAL_SCROLL_PERCENTAGE / 100);
    // const currentFocusedSectionItem = Math.ceil(
    //   (currentScrollPosition + sectionViewportWidth) / sectionViewportWidth
    // );
    var currentFocusedSectionItem = Math.ceil(currentScrollPosition / (slideOffset - widthOffset)) + 1; // As this starts with 1 already
    setCarouselIndicatorConfigs(function(data) {
        var newScrollPercentage = Math.ceil(scrollPercent - offsetPosition + INITIAL_SCROLL_PERCENTAGE);
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, data), {
            direction: newScrollPercentage >= data.scrollPercentage ? "to-right" : "to-left",
            scrollPercentage: newScrollPercentage,
            currentFocusedSectionItem: Math.ceil(newScrollPercentage) === INITIAL_SCROLL_PERCENTAGE || Math.floor(newScrollPercentage) === INITIAL_SCROLL_PERCENTAGE ? 1 : currentFocusedSectionItem,
            currentFocusedSectionExact: currentScrollPosition / (slideOffset - widthOffset) + 1
        });
    });
}
function getShift(itemsContainerRef, showAutoRotation, slideOffset, columnShiftWidth) {
    var currentScrollPosition = itemsContainerRef === null || itemsContainerRef === void 0 ? void 0 : itemsContainerRef.scrollLeft;
    var shift = !showAutoRotation ? slideOffset : columnShiftWidth;
    var extraCoveredShift = Math.floor(currentScrollPosition % shift);
    var remainingShiftForward = shift - extraCoveredShift;
    var remainingShiftBackward = shift + extraCoveredShift;
    return {
        remainingShiftBackward: remainingShiftBackward,
        remainingShiftForward: Math.floor(remainingShiftForward) || shift + remainingShiftForward
    };
}
function useGetArrowMethods(stopAutoRotation, startAutoRotation) {
    var onNextArrowClick = function onNextArrowClick() {
        var remainingShiftForward = getShift(itemContainerRef, showAutoRotation, slideOffset, columnWidthShift).remainingShiftForward;
        stopAutoRotation();
        itemContainerRef === null || itemContainerRef === void 0 ? void 0 : itemContainerRef.scrollBy({
            top: 0,
            left: remainingShiftForward,
            behavior: "smooth"
        });
        startAutoRotation();
    };
    var onPrevArrowClick = function onPrevArrowClick() {
        var remainingShiftBackward = getShift(itemContainerRef, showAutoRotation, slideOffset, columnWidthShift).remainingShiftBackward;
        stopAutoRotation();
        itemContainerRef === null || itemContainerRef === void 0 ? void 0 : itemContainerRef.scrollBy({
            top: 0,
            left: -remainingShiftBackward,
            behavior: "smooth"
        });
        startAutoRotation();
    };
    var carouselScrollTo = function carouselScrollTo(index) {
        var instantScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        stopAutoRotation();
        itemContainerRef === null || itemContainerRef === void 0 ? void 0 : itemContainerRef.scrollTo({
            left: columnWidthShift * index,
            behavior: instantScroll ? "instant" : "smooth"
        });
        startAutoRotation();
    };
    var data = (0,_context_ListPresentationContext__WEBPACK_IMPORTED_MODULE_4__/* .useListPresentationContextData */ .ds)();
    var itemContainerRef = data.refs.itemContainerRef;
    var getConfigsAndUtils = data.utilities.getConfigsAndUtils;
    var _generalValues = getConfigsAndUtils().generalValues, showAutoRotation = _generalValues.showAutoRotation, slideOffset = _generalValues.slideOffset, columnWidthShift = _generalValues.columnWidthShift;
    return {
        onNextArrowClick: onNextArrowClick,
        onPrevArrowClick: onPrevArrowClick,
        carouselScrollTo: carouselScrollTo
    };
}
/* No padding is applied when carousel layout is chosen on mobile so scroll is from one screen edge
to another, so a margin is given on first & last element to give initial spacing before scroll starts **/ var getCardFrameCustomStyle = function(param) {
    var isLayoutCarousel = param.isLayoutCarousel, isMobile = param.isMobile, contentHorizontalPadding = param.contentHorizontalPadding, index = param.index, arr = param.arr;
    var margin = "";
    if (isLayoutCarousel && isMobile) {
        if (!index) margin = "0px 0px 0px ".concat(contentHorizontalPadding, "px");
        if (index === arr.length - 1) margin = "0px  ".concat(contentHorizontalPadding, "px 0px 0px");
    }
    return {
        margin: margin
    };
};
function getColumnGap(param) {
    var isMobile = param.isMobile, type = param.type, isLayoutTypeCard = param.isLayoutTypeCard, listPresentationConfig = param.listPresentationConfig, expandSelectedReel = param.expandSelectedReel;
    var layoutName = listPresentationConfig.layoutName;
    if (type === "icon" || type === "image") {
        return isMobile ? isLayoutTypeCard ? 8 : 16 : (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.columnGap) >= 0 ? listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.columnGap : 44;
    }
    if (type === "logoSlider") return isMobile ? !isLayoutTypeCard ? 16 : 10 : 20;
    if (type === "blog") return isMobile ? 10 : 32;
    if (type === "featuredReels" && expandSelectedReel) return isMobile ? 20 : 32;
    if (type === "testimonials") return isMobile ? !isLayoutTypeCard ? 16 : 12 : !isLayoutTypeCard ? 44 : 20;
    if (type === src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS_NAMES.GALLERY */ .G.GALLERY) return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap) || 20;
    if (type === "instagram") return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.showGapBetweenImages) ? 0 : 8;
    if (type === src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS_NAMES.PRODUCT_TESTIMONIAL */ .G.PRODUCT_TESTIMONIAL) {
        var ref, ref1;
        var isCarousel = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel";
        var isAppearanceCard = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.appearance) === src_components_WidgetMaker_WidgetDnD_WidgetProperties_ProductTestimonials_ProductTestimonialsConfig__WEBPACK_IMPORTED_MODULE_5__.CARD;
        var GAP_ACC_TO_LAYOUT = src_components_WidgetMaker_WidgetDnD_WidgetProperties_ProductTestimonials_ProductTestimonialsConfig__WEBPACK_IMPORTED_MODULE_5__.PRODUCT_TESTIMONIAL_GAP[layoutName];
        var CURRENT_GAP_TYPE = isCarousel ? GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : GAP_ACC_TO_LAYOUT.carousel : GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : GAP_ACC_TO_LAYOUT.grid;
        var isCardSpacing = isAppearanceCard && (GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : GAP_ACC_TO_LAYOUT.card);
        return isMobile ? isCardSpacing ? GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : (ref = GAP_ACC_TO_LAYOUT.card) === null || ref === void 0 ? void 0 : ref.mobile : CURRENT_GAP_TYPE === null || CURRENT_GAP_TYPE === void 0 ? void 0 : CURRENT_GAP_TYPE.mobile : isCardSpacing ? GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : (ref1 = GAP_ACC_TO_LAYOUT.card) === null || ref1 === void 0 ? void 0 : ref1.desktop : CURRENT_GAP_TYPE.desktop;
    }
    return isMobile ? 10 : 20;
}
function getRowGap(isMobile, type, isLayoutTypeCard, isTextNameBelow, isCollectionNameVisible, numColumns, listPresentationConfig) {
    var layoutName = listPresentationConfig.layoutName;
    if (type === "icon" || type === "image") return !isMobile ? 44 : isLayoutTypeCard ? 8 : 16;
    if (type === "logoSlider") return !isMobile ? 20 : !isLayoutTypeCard ? 20 : 10;
    if (type === "blog") return isMobile ? isLayoutTypeCard ? 10 : 24 : 32;
    if (type === "testimonials") return isMobile ? !isLayoutTypeCard ? 44 : 12 : !isLayoutTypeCard ? 64 : 20;
    if (type === src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS_NAMES.GALLERY */ .G.GALLERY) return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.rowColumnGap) || 20;
    if (type === "instagram") return (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.showGapBetweenImages) ? 0 : 8;
    if (type === src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS_NAMES.PRODUCT_TESTIMONIAL */ .G.PRODUCT_TESTIMONIAL) {
        var ref, ref1, ref2, ref3;
        var isAppearanceCard = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.appearance) === src_components_WidgetMaker_WidgetDnD_WidgetProperties_ProductTestimonials_ProductTestimonialsConfig__WEBPACK_IMPORTED_MODULE_5__.CARD;
        var GAP_ACC_TO_LAYOUT = src_components_WidgetMaker_WidgetDnD_WidgetProperties_ProductTestimonials_ProductTestimonialsConfig__WEBPACK_IMPORTED_MODULE_5__.PRODUCT_TESTIMONIAL_GAP[layoutName];
        var isCardSpacing = isAppearanceCard && (GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : GAP_ACC_TO_LAYOUT.card);
        return isMobile ? isCardSpacing ? GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : (ref = GAP_ACC_TO_LAYOUT.card) === null || ref === void 0 ? void 0 : ref.mobile : GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : (ref1 = GAP_ACC_TO_LAYOUT.row) === null || ref1 === void 0 ? void 0 : ref1.mobile : isCardSpacing ? GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : (ref2 = GAP_ACC_TO_LAYOUT.card) === null || ref2 === void 0 ? void 0 : ref2.desktop : GAP_ACC_TO_LAYOUT === null || GAP_ACC_TO_LAYOUT === void 0 ? void 0 : (ref3 = GAP_ACC_TO_LAYOUT.row) === null || ref3 === void 0 ? void 0 : ref3.desktop;
    }
    return !isMobile ? isTextNameBelow && isCollectionNameVisible ? 40 : 20 : isTextNameBelow && isCollectionNameVisible ? 36 : 10;
}
var getGridGapsForAxes = function(param) {
    var isMobile = param.isMobile, cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig, type = param.type, isLayoutTypeCard = param.isLayoutTypeCard, expandSelectedReel = param.expandSelectedReel, numColumns = param.numColumns;
    var ref = (0,_CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_1__/* .getCardConfigurations */ .JH)(cardFrameConfig), isTextNameBelow = ref.isTextNameBelow, isCollectionNameVisible = ref.isCollectionNameVisible;
    return {
        columnGap: getColumnGap({
            isMobile: isMobile,
            type: type,
            isLayoutTypeCard: isLayoutTypeCard,
            listPresentationConfig: listPresentationConfig,
            expandSelectedReel: expandSelectedReel
        }),
        rowGap: getRowGap(isMobile, type, isLayoutTypeCard, isTextNameBelow, isCollectionNameVisible, numColumns, listPresentationConfig)
    };
};
var getReelCardConfigs = function(config) {
    var isCardLayout = (config === null || config === void 0 ? void 0 : config.appearance) === "card";
    var isFullWidth = isCardLayout && (config === null || config === void 0 ? void 0 : config.imageWidth) === "fullWidth";
    var style = {
        background: isCardLayout ? config === null || config === void 0 ? void 0 : config.backgroundColor : "transparent",
        borderColor: isCardLayout ? config === null || config === void 0 ? void 0 : config.borderColor : "#111C361F"
    };
    var className = isCardLayout ? "tw-border-[1px] tw-border-solid" : "";
    return {
        style: style,
        className: className,
        isCardLayout: isCardLayout,
        isFullWidth: isFullWidth
    };
};
function checkIsSliderFullWidth(param) {
    var cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig;
    return isLogoSliderFullWidth({
        cardFrameConfig: cardFrameConfig,
        listPresentationConfig: listPresentationConfig
    }) || isTestimonialSliderFullWidth({
        listPresentationConfig: listPresentationConfig
    });
}
function isLogoSliderAutoScroll(param) {
    var cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig;
    return (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.autoScroll) && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel";
}
function isLogoSliderFullWidth(param) {
    var cardFrameConfig = param.cardFrameConfig, listPresentationConfig = param.listPresentationConfig;
    return (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.scrollFullWidth) && (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.autoScroll) && (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.layoutType) === "carousel";
}
function isTestimonialSliderFullWidth(param) {
    var listPresentationConfig = param.listPresentationConfig;
    var ref;
    var isTestimonial = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === "testimonials" || (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : listPresentationConfig.type) === src_constants_widgets__WEBPACK_IMPORTED_MODULE_3__/* .ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type */ .Pe.PRODUCT_TESTIMONIALS.type;
    var isAutoScroll = (listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.autoPlayConfig) === null || ref === void 0 ? void 0 : ref.type) === _components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_2__/* .SCROLL_TYPE.AUTO_SCROLL */ .ej.AUTO_SCROLL;
    return isTestimonial && isAutoScroll;
}
var getRenderCardOverrides = function(param) {
    var listPresentationConfig = param.listPresentationConfig, sectionColors = param.sectionColors;
    var ref, ref1, ref2, ref3;
    if (!(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref = listPresentationConfig.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.defaultOverrides) === null || ref1 === void 0 ? void 0 : ref1.isEnabled)) {
        return "";
    }
    switch(listPresentationConfig === null || listPresentationConfig === void 0 ? void 0 : (ref2 = listPresentationConfig.colors) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.defaultOverrides) === null || ref3 === void 0 ? void 0 : ref3.colorSchemeName){
        case "custom":
            return sectionColors === null || sectionColors === void 0 ? void 0 : sectionColors.text;
        case "white":
            return "#ffffff";
        default:
            return "";
    }
};
function getBlogData(blogList) {
    var simplifiedBlogData = blogList === null || blogList === void 0 ? void 0 : blogList.map(function(data) {
        return {
            imageDetail: {
                url: (data === null || data === void 0 ? void 0 : data.featured_image) || ""
            },
            title: (data === null || data === void 0 ? void 0 : data.page_name) || "",
            description: (data === null || data === void 0 ? void 0 : data.excerpt) || "",
            date: (data === null || data === void 0 ? void 0 : data.updated_at) || "",
            slug: (data === null || data === void 0 ? void 0 : data.slug_url) || ""
        };
    });
    return simplifiedBlogData;
}
function getPaddingForInstaWidget(listPresentation, isMobile) {
    var isLayout2 = listPresentation.layoutName === _ListPresentation_components_Testimonials_Constants__WEBPACK_IMPORTED_MODULE_6__/* .COMMON_LAYOUT_TYPE.TWO */ .o_.TWO;
    if (isMobile) {
        if (isLayout2) {
            return "20px 20px 0 20px";
        } else {
            return "0px 20px";
        }
    } else if (!isMobile) {
        if (isLayout2) {
            return "20px 0 0 0";
        } else {
            return "0";
        }
    }
}


/***/ })

}]);